<div class="vh-100 overflow-hidden" [ngClass]="theme ? '': 'dark' ">
  <div class="row m-0"
    [ngClass]="[theme ? 'bg-light': 'banner',voluman_data?.length==0 || !isLogin  ? '' : 'content-wrapper1']">
    <div class="d-flex align-items-center justify-content-between p-4 border-bottom"
      style="height:48px;justify-content: center !important;"
      *ngIf="(!loading && !isLogin) && activateLink !== 'hidden'">
      <div class="uk-width-1-2@m" *ngIf="!isLogin">
        <div class="st-danger-text">
          To Start analyzing the keywords, You need to at least have a free strell account. <a
            href="https://app.strell.io/login" target="_blank">Login to analyze SERPs.</a>

        </div>
      </div>
      <div class="d-flex align-items-center">
        <ng-container *ngIf="excelLoader">
          <i class="bi bi-dot fs-3 text-danger"></i>
          <div class="d-flex justify-content-center align-items-center ms-2">
            Downloading Excel File
            <div class="spinner-border text-primary ms-2" role="status"></div>
          </div>
        </ng-container>

      </div>
    </div>
    <div class="row m-0 p-0" [ngClass]="!isLogin ? 'sidebar-height' : 'sidebar-height-sm'">
      <div class="p-0 overflow-auto" [ngClass]="!!isSidebarOpen ? 'sidebar ps-3 border-end' : 'sidebar-sm'">
        <!-- Filters -->
        <div class="pt-3">
          <h3 class="m-0 fw-600 filter-toggle heading" (click)="isSidebarOpen = false"><i
              class="bi bi-arrow-left-square-fill"></i> Filter <span class="text-primary fw-normal">({{activeFilterCount
              +
              weakSpotFilter.length + intentFilter.length + forumFilter.length + statusFilter.length +
              serpScoreFilter.length}} selected)</span></h3>
          <button class="btn btn-outline-primary mt-3 fs-13" ngbPopover="Clear all filters" popoverClass="{{popover}}"
            container="body" triggers="mouseenter:mouseleave" (click)="clearAllFilter()">Clear All</button>
          <mat-accordion>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <p class="m-0 fw-600">DA</p>
                <i class="bi bi-exclamation-circle-fill text-secondary ms-2" triggers="mouseenter:mouseleave"
                  [ngbPopover]="DA" popoverClass="{{popover}} right-pop" container="body"></i>
              </mat-expansion-panel-header>
              <ng-template #DA>
                <div class="d-flex align-items-center mb-0 left-score">
                  <p class="mb-0">Identify Low DA Keywords - Rapidly locate keywords associated with both DA<10 and
                      DA<20 websites.</p>
                </div>
              </ng-template>
              <div class="mt-3 d-flex justify-content-start flex-wrap">
                <button class="btn btn-outline-primary py-1 px-3 fs-13 light-txt me-2 mb-2"
                  [ngClass]="{'isActiveChip' : daLessthan10 }" (click)="setActive('lessThan10')">DA &lt; 10 </button>
                <button class="btn btn-outline-primary py-1 px-3 fs-13 light-txt mb-2" (click)="setActive('lessThan20')"
                  [ngClass]="{'isActiveChip' : daLessthan20}">DA &lt; 20 </button>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <mat-accordion>

            <mat-expansion-panel (opened)="panelOpenStatetopic = true" (closed)="panelOpenStatetopic = false">

              <mat-expansion-panel-header>
                <p class="m-0 fw-600">Topics</p>
                <i class="bi bi-exclamation-circle-fill text-secondary ms-2" [ngbPopover]="Topics"
                  popoverClass="{{popover}}" container="body" triggers="mouseenter:mouseleave"></i>
                <ng-template #Topics>
                  <div class="left-score">
                    <p class="mb-0">Discovered Topics in Current Report - View the topics identified within the current
                      keyword report</p>

                  </div>
                </ng-template>

              </mat-expansion-panel-header>

              <div style="height: 350px;overflow-y:auto;overflow-x: hidden;position: relative;">

                <div *ngIf="topicloading" style="position: absolute;
                    top: 50%;
                    left: 40%;
                    display: flex;">
                  <span style="font-size: 20px;">Loading...</span>
                  <span class="topicloader"></span>
                </div>
                <div *ngIf="!topicloading" class="d-flex flex-wrap pt-2">
                  <input type="text" class="form-control input m-2" placeholder="Search for Topic ..."
                    [(ngModel)]="searchTopic" (keyup)="filterTopic()">
                  <span style="user-select: none;text-transform: capitalize;align-items: center;"
                    class="border border-secondary py-1 px-3 rounded-pill m-1 light-txt" *ngFor="let data of topicData;"
                    (click)="selectChip(data)" [ngClass]="{'isActiveChip' : topicFilter.includes(data.datas)}"
                    role="button">{{data.datas}}</span>
                </div>
              </div>


              <div class="col-12 mt-1 mb-3 row m-0 align-items-center justify-content-end">
                <button class="btn btn-outline-primary w-auto btn-small fs-13" (click)="topicclear()"
                  [disabled]="countedWord < 1">Clear
                  All</button>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          <mat-accordion>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <p class="m-0 fw-600">Intent</p>
                <i class="bi bi-exclamation-circle-fill text-secondary ms-2" triggers="mouseenter:mouseleave"
                  [ngbPopover]="Intent" popoverClass="{{popover}}" container="body"></i>
              </mat-expansion-panel-header>
              <ng-template #Intent>
                <div class="left-score">
                  <p class="mb-0">Sort the keywords according to the intent behind the keyword</p>
                </div>
              </ng-template>
              <div class="border-bottom p-1">
                <div class="d-flex align-items-center justify-content-between mb-3"
                  *ngFor="let item of intentMenuArray">
                  <div class="d-flex align-items-center">
                    <p class="m-0 filter-font-color" *ngIf="item==='high_intent'">Hight-Intent</p>
                    <p class="m-0 filter-font-color" *ngIf="item==='pre_purchase'">Pre-Purchase</p>
                    <p class="m-0 filter-font-color" *ngIf="item==='post_purchase'">Post-Purchase</p>
                    <p class="m-0 filter-font-color" *ngIf="item==='comparison'">Comparision</p>

                    <ng-container *ngIf="item==='high_intent'">
                      <i class="bi bi-exclamation-circle-fill light-txt ms-1 text-secondary"
                        triggers="mouseenter:mouseleave" container="body" [ngbPopover]="highIntent"
                        popoverClass="{{popover}}"></i>
                    </ng-container>
                    <ng-container *ngIf="item==='pre_purchase'">
                      <i class="bi bi-exclamation-circle-fill light-txt ms-1 text-secondary"
                        triggers="mouseenter:mouseleave" container="body" [ngbPopover]="PrePurchase"
                        popoverClass="{{popover}}"></i>
                    </ng-container>
                    <ng-container *ngIf="item==='post_purchase'">
                      <i class="bi bi-exclamation-circle-fill light-txt ms-1 text-secondary"
                        triggers="mouseenter:mouseleave" container="body" [ngbPopover]="PostPurchase"
                        popoverClass="{{popover}}"></i>
                    </ng-container>
                    <ng-container *ngIf="item==='comparison'">
                      <i class="bi bi-exclamation-circle-fill light-txt ms-1 text-secondary"
                        triggers="mouseenter:mouseleave" container="body" [ngbPopover]="Comparison"
                        popoverClass="{{popover}}"></i>
                    </ng-container>
                    <ng-template #highIntent>
                      <div class="mb-2 max-272">
                        <div>
                          High Intent: Shows all the keywords which have following keywords in it
                        </div>
                        <div>
                          1. Best
                        </div>
                        <div>
                          2. Review
                        </div>
                        <div>
                          3. Free
                        </div>
                      </div>
                    </ng-template>
                    <ng-template #PrePurchase>
                      <div class="mb-2 max-272">
                        <div>
                          Pre-Purchase: Show all the keywords which have following keywords in it
                        </div>
                        <div>
                          1. Discounts
                        </div>
                        <div>
                          2. Best
                        </div>
                        <div>
                          3. Review
                        </div>
                        <div>
                          4. Buy
                        </div>
                      </div>
                    </ng-template>
                    <ng-template #PostPurchase>
                      <div class="mb-2 max-272">
                        <div>
                          Post-purchase: Show all the keywords which have follwing keywords in it
                        </div>
                        <div>
                          1. Problem
                        </div>
                        <div>
                          2. Warranty
                        </div>
                        <div>
                          3. Broken
                        </div>
                        <div>
                          4. clean
                        </div>
                      </div>
                    </ng-template>
                    <ng-template #Comparison>
                      <div class="mb-2 max-272">
                        <div>
                          Comparison: Show all the keywords which have follwing keywords in it
                        </div>
                        <div>
                          1. vs
                        </div>
                        <div>
                          2. Compare
                        </div>
                        <div>
                          3. Comparison
                        </div>
                        <div>
                          4. alternative
                        </div>
                        <div>
                          5. alternatives
                        </div>
                        <div>
                          6. Difference
                        </div>
                        <div>
                          7. Compared to
                        </div>
                      </div>
                    </ng-template>
                  </div>
                  <div class="d-flex align-items-center">
                    <mat-slide-toggle [checked]="intentFilter.includes(item)" color="primary" class="ms-2"
                      (change)="toggleFilter('Intent',item,$event)"></mat-slide-toggle>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          <mat-accordion>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <p class="m-0 fw-600">Status</p>
              </mat-expansion-panel-header>
              <div class="border-bottom p-1">
                <div class="d-flex align-items-center justify-content-between mb-3"
                  *ngFor="let item of statusMenuArray">
                  <p class="m-0 filter-font-color" *ngIf="item==='analyzed'">Analyzed</p>
                  <p class="m-0 filter-font-color" *ngIf="item==='not_analyzed'">Not Analyzed</p>

                  <div class="d-flex align-items-center">
                    <!-- <span class="chip-blue me-4">100%</span> -->
                    <mat-slide-toggle [checked]="statusFilter.includes(item)" color="primary" class="ms-2"
                      (change)="toggleFilter('Status',item,$event)"></mat-slide-toggle>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          <mat-accordion>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <p class="m-0 fw-600">Volume</p>
              </mat-expansion-panel-header>
              <div class="border-bottom p-1">
                <!-- <div class="d-flex justify-content-between align-items-center py-2 p-0">
                    <h4 class="m-0 fw-600 fs-16">Volume</h4>
                    <mat-icon class="text-light-gray fs-20">keyboard_arrow_right</mat-icon>
                  </div> -->
                <div class="input-box position-relative col-12 row m-0">
                  <!-- <div class="col-6 p-0 pe-1">
                      <label for="">Min</label> -->
                  <input type="number" class="first-input input" min="0" max="10" [(ngModel)]="volFilter.min"
                    (keyup)="success('vol')" placeholder="From">
                  <!-- </div> -->
                  <!-- <div class="col-6 p-0 ps-1">
                      <label for="">Max</label> -->
                  <input type="number" class="second-input input" min="0" max="10" [(ngModel)]="volFilter.max"
                    (keyup)="success('vol')" placeholder="To">
                  <!-- </div> -->
                </div>
                <div class="col-12 my-3 row m-0 align-items-center justify-content-end">
                  <button class="btn btn-outline-primary w-auto me-2 fs-13" (click)="clearFilter('vol')">Clear
                    All</button>
                  <button id="volApply" class="btn btn-outline-primary w-auto fs-13"
                    [disabled]="(!volFilter.max) || volFilter.min > volFilter.max"
                    (click)="filterValue('vol',volFilter.min,volFilter.max)">Apply</button>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          <mat-accordion>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <p class="m-0 fw-600">CPC</p>
              </mat-expansion-panel-header>
              <div class="border-bottom p-1">
                <!-- <div class="d-flex justify-content-between align-items-center py-2 p-0">
                    <h4 class="m-0 fw-600 fs-16">CPC</h4>
                    <mat-icon class="text-light-gray fs-20">keyboard_arrow_right</mat-icon>
                  </div> -->
                <div class="input-box position-relative row m-0">
                  <!-- <div class="col-6 p-0">
                      <label for="">Min</label> -->
                  <input type="number" min="0" max="10" class="first-input input" [(ngModel)]="cpcFilter.min"
                    (keyup)="success('cpc')" placeholder="From">
                  <!-- </div> -->
                  <!-- <div class="col-6 p-0">
                      <label for="">Max</label> -->
                  <input type="number" min="0" max="10" class="second-input input" [(ngModel)]="cpcFilter.max"
                    (keyup)="success('cpc')" placeholder="To">
                  <!-- </div> -->
                </div>
                <div class="col-12 my-3 row m-0 align-items-center justify-content-end">
                  <button class="btn btn-outline-primary w-auto me-2 fs-13" (click)="clearFilter('cpc')">Clear
                    All</button>
                  <button id="cpcApply" class="btn btn-outline-primary w-auto fs-13"
                    [disabled]="(!cpcFilter.max) || cpcFilter.min > cpcFilter.max"
                    (click)="filterValue('cpc',cpcFilter.min,cpcFilter.max)">Apply</button>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          <mat-accordion>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <p class="m-0 fw-600">Weak Spots</p>
              </mat-expansion-panel-header>
              <div class="border-bottom p-1">
                <!-- <div class="d-flex justify-content-between align-items-center py-2">
                    <h4 class="m-0 fw-600 fs-16">Weak Spots</h4>
                    <mat-icon class="text-light-gray fs-20">keyboard_arrow_right</mat-icon>
                  </div> -->
                <div class="d-flex align-items-center justify-content-between mb-3"
                  *ngFor="let item of weakSpotMenuArray">
                  <p class="m-0 filter-font-color">{{item}}
                    <i class="bi bi-exclamation-circle-fill text-secondary ms-2" triggers="mouseenter:mouseleave"
                      [ngbPopover]="weakSpot" popoverClass="{{popover}}" placement="top"></i>
                    <!-- <span class="bi bi-info-circle ps-1" matTooltip="At least a weak spot in the top 10 search results"  matTooltipClass="{{theme ? 'custom-tooltip' : ''}}" [ngClass]="theme ? 'light-info': 'dark-info'"></span> -->
                  </p>
                  <ng-template #weakSpot>
                    <div class="left-score">
                      <p class="mb-0">At least a weak spot in the top 10 search results</p>
                    </div>
                  </ng-template>
                  <div class="d-flex align-items-center">
                    <mat-slide-toggle [checked]="weakSpotFilter.includes(item)" color="primary" class="ms-2"
                      (change)="toggleFilter('Weak Spots',item,$event)"></mat-slide-toggle>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          <mat-accordion>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <p class="m-0 fw-600">Forums</p>
                <i class="bi bi-exclamation-circle-fill text-secondary ms-2" triggers="mouseenter:mouseleave"
                  [ngbPopover]="Forums" popoverClass="{{popover}}" container="body"></i>
              </mat-expansion-panel-header>
              <ng-template #Forums>
                <div class="left-score">
                  <p class="mb-0">At least a Forum in the top 10 search results</p>
                </div>
              </ng-template>
              <div class="border-bottom p-1">
                <!-- <div class="d-flex justify-content-between align-items-center py-2 p-0">
                    <h4 class="m-0 fw-600 fs-16">Forums</h4>
                    <mat-icon class="text-light-gray fs-20">keyboard_arrow_right</mat-icon>
                  </div> -->
                <div class="d-flex align-items-center justify-content-between mb-3"
                  *ngFor="let item of formusMenuArray">
                  <p class="m-0 filter-font-color filter-font-color">{{item}}</p>
                  <div class="d-flex align-items-center">
                    <mat-slide-toggle [checked]="forumFilter.includes(item)" color="primary" class="ms-2"
                      (change)="toggleFilter('Forums',item,$event)"></mat-slide-toggle>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          <mat-accordion>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <p class="m-0 fw-600">SERP Score</p>
                <i class="bi bi-exclamation-circle-fill text-secondary ms-2" triggers="mouseenter:mouseleave"
                  [ngbPopover]="se" popoverClass="{{popover}}" container="body"></i>
              </mat-expansion-panel-header>
              <ng-template #se>
                <div class="left-score">
                  <p class="mb-0">Sort keywords according to the SERP Score</p>
                </div>
              </ng-template>
              <div class="border-bottom p-1">
                <!-- <div class="d-flex justify-content-between align-items-center py-2 p-0">
                    <h4 class="m-0 fw-600 fs-16">SERP Score</h4>
                    <mat-icon class="text-light-gray fs-20">keyboard_arrow_right</mat-icon>
                  </div> -->
                <div class="d-flex align-items-center justify-content-between mb-3"
                  *ngFor="let item of serpScoreMenuArray">
                  <p class="m-0 filter-font-color">{{item}}</p>
                  <div class="d-flex align-items-center">
                    <mat-slide-toggle [checked]="serpScoreFilter.includes(item)" color="primary" class="ms-2"
                      (change)="toggleFilter('SERP Score',item,$event)"></mat-slide-toggle>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <p class="m-0 fw-600">Include</p>
                <i class="bi bi-exclamation-circle-fill text-secondary ms-2" triggers="mouseenter:mouseleave"
                  [ngbPopover]="Include" popoverClass="{{popover}}" container="body"></i>

              </mat-expansion-panel-header>
              <ng-template #Include>
                <div class="left-score">
                  <p class="mb-0">Include specific keywords or keyword phrases</p>
                </div>
              </ng-template>
              <div style="max-height: 300px;overflow-y:auto;overflow-x: hidden;position: relative;">
                <div>
                  <div style="display:flex" class="m-2">
                    <input type="text" class="form-control me-1 mr-1 rounded-3" placeholder="Enter keyword"
                      [(ngModel)]="includeKeyword">
                    <button [disabled]="includeKeyword == ''" matTooltip="Include Keyword"
                      class="btn btn-outline-primary w-auto me-2 fs-13" (click)="addIncludeKeyword('Any')"><i
                        class="bi bi-bookmark-plus-fill"></i></button>
                  </div>
                  <div style="max-height: 200px;overflow-y: auto;">
                    <div class="d-flex flex-wrap pt-2">
                      <div style="text-transform: capitalize;"
                        class="d-flex align-items-center justify-content-center border border-secondary py-1 px-2 rounded-pill m-1 light-txt"
                        *ngFor="let data of include_any_keywords;" (click)="selectAnyChip(data,'include')"
                        [ngClass]="{'isActiveChip' : data.selected == true}" role="button">{{data.title}}<i
                          class="bi bi-x fs-20 ms-2 line-2" role="button"
                          (click)="removeIncludeKeyword(data.title,'Any')"></i></div>
                    </div>
                  </div>
                </div>
                <!-- <mat-tab-group (selectedTabChange)="tabChanged($event)" mat-stretch-tabs="false" mat-align-tabs="start"
                    [ngClass]="theme ? '' : 'dark-tab'">
  
                    <mat-tab label="Exact">
                      <div>
                        <div style="display:flex" class="m-2">
                          <input type="text" class="form-control me-1 mr-1 rounded-3" placeholder="Enter keyword"
                            [(ngModel)]="includeKeyword">
                          <button [disabled]="includeKeyword == ''" matTooltip="Include Keyword"
                            class="btn btn-outline-primary w-auto me-2 fs-13" (click)="addIncludeKeyword('Fix')"><i
                              class="bi bi-bookmark-plus-fill"></i></button>
                        </div>
                        <div style="max-height: 200px;overflow-y: auto;">
                          <div class="d-flex flex-wrap pt-2">
                            <div style="text-transform: capitalize;"
                              class="d-flex align-items-center justify-content-center border border-secondary py-1 px-2 rounded-pill m-1 light-txt"
                              *ngFor="let data of include_fix_keywords;" (click)="selectFixChip(data)"
                              [ngClass]="{'isActiveChip' : data.selected == true}" role="button">{{data.title}} <i
                                class="bi bi-x fs-20 ms-2 line-2" role="button"
                                (click)="removeIncludeKeyword(data.title,'Fix')"></i></div>
                          </div>
                        </div>
                      </div>
                    </mat-tab>
                    <mat-tab label="Partial">
                      <div>
                        <div style="display:flex" class="m-2">
                          <input type="text" class="form-control me-1 mr-1 rounded-3" placeholder="Enter keyword"
                            [(ngModel)]="includeKeyword">
                          <button [disabled]="includeKeyword == ''" matTooltip="Include Keyword"
                            class="btn btn-outline-primary w-auto me-2 fs-13" (click)="addIncludeKeyword('Any')"><i
                              class="bi bi-bookmark-plus-fill"></i></button>
                        </div>
                        <div style="max-height: 200px;overflow-y: auto;">
                          <div class="d-flex flex-wrap pt-2">
                            <div style="text-transform: capitalize;"
                              class="d-flex align-items-center justify-content-center border border-secondary py-1 px-2 rounded-pill m-1 light-txt"
                              *ngFor="let data of include_any_keywords;" (click)="selectAnyChip(data)"
                              [ngClass]="{'isActiveChip' : data.selected == true}" role="button">{{data.title}}<i
                                class="bi bi-x fs-20 ms-2 line-2" role="button"
                                (click)="removeIncludeKeyword(data.title,'Any')"></i></div>
                          </div>
                        </div>
                      </div>
  
                    </mat-tab>
                  </mat-tab-group> -->

              </div>
            </mat-expansion-panel>
          </mat-accordion>
          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <p class="m-0 fw-600">Exclude</p>
                <i class="bi bi-exclamation-circle-fill text-secondary ms-2" triggers="mouseenter:mouseleave"
                  [ngbPopover]="Exclude" popoverClass="{{popover}}" container="body"></i>

              </mat-expansion-panel-header>
              <ng-template #Exclude>
                <div class="left-score">
                  <p class="mb-0">Exclude specific keywords or keyword phrases</p>
                </div>
              </ng-template>
              <div style="max-height: 300px;overflow-y:hidden;overflow-x: hidden;position: relative;">
                <div style="display:flex" class="m-2">
                  <input type="text" class="form-control me-1 mr-1 rounded-3" placeholder="Enter keyword"
                    [(ngModel)]="excludeKeyword">
                  <button [disabled]="excludeKeyword == ''" matTooltip="Exclude Keyword"
                    class="btn btn-outline-primary w-auto me-2 fs-13" (click)="addExcludeKeywords('All')"><i
                      class="bi bi-bookmark-plus-fill"></i></button>
                </div>
                <div style="max-height: 200px;overflow-y: auto; padding-bottom: 10px;">
                  <div class="d-flex flex-wrap pt-2">
                    <div style="text-transform: capitalize;"
                      class="d-flex align-items-center justify-content-center border border-secondary py-1 px-2 rounded-pill m-1 light-txt"
                      *ngFor="let data of exclude_any_keywords;" (click)="selectAnyChip(data,'exclude')" role="button">
                      {{data.text}}<i class="bi bi-x fs-20 ms-2 line-2" role="button"
                        (click)="removeExcludeKeyword(data.text)"></i></div>

                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
      <div
        [ngClass]="[!!isSidebarOpen ? 'content-wrapper-sm' : 'content-wrapper',!isLogin ? 'main-content-wrapper1' : ' main-content-wrapper']"
        class="p-0 overflow-auto pb-3" (scroll)="onWindowScroll($event)">
        <!-- Tabs and search -->
        <div>
          <div class="py-3 pb-0 d-flex align-items-center justify-content-between ps-4 pe-3">
            <!-- <i class="bi bi-funnel-fill me-3 sidebar-toggle" (click)="isSidebarOpen = false"
                *ngIf="isSidebarOpen"></i> -->
            <div class="">
              <i class="bi bi-funnel me-3 sidebar-toggle" (click)="isSidebarOpen = true"
                *ngIf="!isSidebarOpen && keyWordType != 'list' "></i>
              <nav class="nav nav-pills align-items-center overflow-hidden" [ngClass]="theme ? 'light-nav': 'dark-nav'">
                <a *ngIf="keyWordType != 'list'" class="nav-link" [ngClass]="{'active': activateLink == 'all'}"
                  role="button" (click)="activeLink('all')" ngbPopover="List of all keywords" popoverClass="{{popover}}"
                  container="body" triggers="mouseenter:mouseleave">All <span
                    class="fw-normal fs-13">({{lckrCountData.total_kws}})</span></a>
                <a *ngIf="keyWordType != 'list'" class="nav-link" role="button"
                  [ngClass]="{'active': activateLink == 'suggestion'}" ngbPopover="List of Suggested keywords"
                  popoverClass="{{popover}}" container="body" triggers="mouseenter:mouseleave"
                  (click)="activeLink('suggestion')">Suggestion <span
                    class="fw-normal fs-13">({{lckrCountData.total_suggestions}})</span></a>
                <a *ngIf="keyWordType != 'list'" class="nav-link" role="button"
                  [ngClass]="{'active': activateLink == 'question'}" ngbPopover="List of questions keywords"
                  popoverClass="{{popover}}" container="body" triggers="mouseenter:mouseleave"
                  (click)="activeLink('question')">Question <span
                    class="fw-normal fs-13">({{lckrCountData.total_questions}})</span></a>
                <a *ngIf="keyWordType != 'list'" class="nav-link" role="button"
                  [ngClass]="{'active': activateLink == 'paa'}"
                  ngbPopover="People also ask question from analyzed keywords" popoverClass="{{popover}}"
                  container="body" triggers="mouseenter:mouseleave" (click)="activeLink('paa')">PAA<span
                    class="fw-normal fs-13">({{lckrCountData.total_paa}})</span></a>
                <a *ngIf="keyWordType != 'list'" class="nav-link" role="button"
                  [ngClass]="{'active': activateLink == 'hidden'}" ngbPopover="List of hidden keywords"
                  popoverClass="{{popover}}" container="body" triggers="mouseenter:mouseleave"
                  (click)="activeLink('hidden')">Hidden <span
                    class="fw-normal fs-13">({{lckrCountData.total_hiddens}})</span></a>
                <a *ngIf="keyWordType != 'list'" class="nav-link" role="button"
                  [ngClass]="{'active': activateLink == 'related_search'}" [ngbPopover]="search"
                  popoverClass="{{popover}}" container="body" triggers="mouseenter:mouseleave"
                  (click)="activeLink('related_search')">Related
                  Searches
                  <span class="fw-normal fs-13">({{lckrCountData.total_related_searches}})</span></a>
                <ng-template #search>
                  <div class="scored">
                    <p class="mb-0">Related search queries are found at the end of<br> the Google SERP for analyzed
                      keywords
                    </p>
                  </div>
                </ng-template>
                <a *ngIf="keyWordType != 'list'" class="nav-link" role="button"
                  [ngClass]="{'active': activateLink == 'competition'}"
                  ngbPopover="List of competitive sites for analyzed keywords" popoverClass="{{popover}}"
                  container="body" triggers="mouseenter:mouseleave" (click)="activeLink('competition')">Competition
                  <span class="fw-normal fs-13">({{lckrCountData.total_competitors}})</span></a>
                <a *ngIf="keyWordType != 'list'" class="nav-link" role="button"
                  [ngClass]="{'active': activateLink == 'clusters'}" ngbPopover="Create clusters of analyzed keywords"
                  popoverClass="{{popover}}" container="body" triggers="mouseenter:mouseleave"
                  (click)="activeLink('clusters')">Clusters
                </a>
                <a *ngIf="keyWordType != 'list'" class="nav-link" role="button"
                  [ngClass]="{'active': activateLink == 'Settings'}" ngbPopover="Settings for a current report"
                  popoverClass="{{popover}}" container="body" triggers="mouseenter:mouseleave"
                  (click)="activateLink = 'Settings'">Settings
                  <!-- <span class="fw -normal">({{clusterLength ? clusterLength :
                        0}})</span> -->
                </a>
              </nav>
            </div>
            <!-- <div class="d-flex align-items-center">
              <p class="p-0 m-0">Remaining keyword analysis</p>
            </div> -->

          </div>

          <div class="d-flex align-items-center justify-content-between mt-3 ps-4 pe-3"
            *ngIf="activateLink!=='Settings'">
            <!-- SEARCH -->
            <div class="w-25">
              <span class="text-primary fs-6 fw-bold">{{keyWordName}}</span><sup
                class="rounded rounded-3 ms-2 bg-secondary text-light p-1" *ngIf="!loading">{{tabWiseCount}}</sup>
            </div>

            <!-- ACTION BUTTONS -->
            <div class="d-flex align-items-center justify-content-end me-5 w-75">
              <div class="position-relative w-100 me-3" *ngIf="activateLink !== 'competition'">
                <i class="bi bi-search text-primary"></i>
                <input type="text" class="form-control input ps-56" placeholder="Search for Keyword ..."
                  [(ngModel)]="searchText" (keyup)="searchKeyword()">
              </div>
              <button class="btn btn-outline-primary py-1 px-2 text-nowrap me-1" (click)="refresh()"
                matTooltip="Refresh for getting new changes"
                *ngIf="isLogin && keyWordType != 'list' && (activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question')">
                <i class="bi bi-arrow-clockwise"></i> Refresh
              </button>
              <button *ngIf="activateLink == 'clusters'" class="btn btn-outline-primary me-1  py-1 px-2 text-nowrap"
                (click)="createContentEditor()" [disabled]="selectedSubClusterId.length==0">Create Content Editor</button>
              <button *ngIf="activateLink == 'clusters'" class="btn btn-outline-primary me-1  py-1 px-2 text-nowrap"
                [disabled]="(topResults || SERPSimilarity) =='' || clustersloading" (click)="startClusturing()">
                  <div class="spinner-border text-primary pt-1" role="status" *ngIf="clustersloading"
                    style="width: 15px !important; height: 15px !important;"></div>
               Start Clusturing</button>

              <button *ngIf="activateLink == 'clusters'" matTooltip="Cluster Data Export"
                class="btn btn-outline-primary me-1  py-1 px-2 text-nowrap" [disabled]="clusteredData.length == 0"
                (click)="exportClusterExcel()"> <i class="bi bi-file-earmark-medical"
                  *ngIf="!clusterExcelLoader;else loading"></i>
                <ng-template #loading>
                  <div class="spinner-border text-primary pt-1" role="status"
                    style="width: 15px !important; height: 15px !important;"></div>
                </ng-template>
              </button>

              <div class="btn-group" role="group" aria-label="Basic example">
                <button class="btn btn-outline-primary py-1 px-2 text-nowrap" *ngIf="activateLink == 'clusters'"
                  [matMenuTriggerFor]="settingsMenu" (menuOpened)="getCredit()">
                  <i class="bi bi-gear"></i> Settings
                </button>
                <button class="btn btn-outline-primary py-1 px-2 text-nowrap" [disabled]="buttonState() || !!isDisable || (!userData || userData?.serp_max_credit - userData?.serp_credit ==0)"
                  (click)="performSerpExtract()" matTooltip="Analyse selected keywords"
                  *ngIf="isLogin && (activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question')">
                  <i class="bi bi-hdd-stack me-1"></i> Analyze Keywords
                </button>
                <button class="btn btn-outline-primary py-1 px-2" ngbPopover="Analyse Intent keywords" [disabled]="(!userData || userData?.serp_max_credit - userData?.serp_credit ==0)"
                  popoverClass="{{popover}}" container="body" triggers="mouseenter:mouseleave"
                  *ngIf="(keyWordType != 'list' && isLogin) && activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question'"
                  [matMenuTriggerFor]="menu" (menuOpened)="getCredit()">
                  <i class="mt-1 bi bi-chevron-down me-1"></i>
                </button>
              </div>
              <button *ngIf="isLogin && keyWordType != 'list'"
                class="btn btn-outline-primary ms-1 py-1 px-2 text-nowrap " [disabled]="buttonState()"
                matTooltip="Hide selected keywords"
                [hidden]="activateLink === 'hidden' || activateLink === 'paa' || activateLink === 'related_search' || activateLink === 'competition'"
                (click)="handleHide(true)">
                <i class="bi bi-eye-slash me-1"></i> Hide
              </button>
              <button class="btn btn-outline-primary ms-1 py-1 px-2 text-nowrap" matTooltip="Unhide selected keywords"
                [disabled]="buttonState()" (click)="handleHide(false)" *ngIf="activateLink === 'hidden'">
                <i class="bi bi-eye me-1"></i> Unhide
              </button>
              <button *ngIf="isLogin && keyWordType != 'list'"
                class="btn btn-outline-primary ml-auto ms-1 py-1 px-2 text-nowrap " (click)="linkCopy()"
                ngbPopover="Share Report" popoverClass="{{popover}}" container="body" triggers="mouseenter:mouseleave">
                <i class="bi bi-clipboard"></i>
              </button>
              <button [disabled]="excelLoader"
                *ngIf="keyWordType==='list'"
                class="btn btn-outline-primary ml-auto ms-1 py-1 px-2 text-nowrap" style="white-space: nowrap;"
                (click)="downloadAllData()" ngbPopover="Export all as excel" popoverClass="{{popover}}" container="body"
                triggers="mouseenter:mouseleave">
                <i class="bi bi-file-earmark-medical" *ngIf="!excelLoader;else loading"></i>
                <ng-template #loading>
                  <div class="spinner-border text-primary pt-1" role="status"
                    style="width: 15px !important; height: 15px !important;"></div>
                </ng-template>
              </button>
              <button [disabled]="excelLoader"
                *ngIf="!isAllChecked && keyWordType !='list' && activateLink !=='clusters' && activateLink !=='paa' && activateLink !=='competition' && activateLink !=='related_search' "
                class="btn btn-outline-primary ml-auto ms-1 py-1 px-2 text-nowrap" style="white-space: nowrap;"
                (click)="downloadAllData()" ngbPopover="Export all as excel" popoverClass="{{popover}}" container="body"
                triggers="mouseenter:mouseleave">
                <i class="bi bi-file-earmark-medical" *ngIf="!excelLoader;else loading"></i>
                <ng-template #loading>
                  <div class="spinner-border text-primary pt-1" role="status"
                    style="width: 15px !important; height: 15px !important;"></div>
                </ng-template>
              </button>

              <button
                *ngIf="(activateLink =='paa' || activateLink == 'competition' || activateLink =='related_search') "
                class="btn btn-outline-primary ml-auto ms-1 py-1 px-2 text-nowrap" style="white-space: nowrap;"
                (click)="downloadAllData()" matTooltip="Export {{activateLink}} data as excel">
                <i class="bi bi-file-earmark-medical" *ngIf="!separateExcelLoader;else loading"></i>
                <ng-template #loading>
                  <div class="spinner-border text-primary pt-1" role="status"
                    style="width: 15px !important; height: 15px !important;"></div>
                </ng-template>
              </button>

              <!-- <button
                *ngIf="isAllChecked && (activateLink =='all' || activateLink == 'suggestion' || activateLink =='question' || activateLink =='Hidden') "
                class="btn btn-outline-primary ml-auto ms-1 py-1 px-2 text-nowrap" style="white-space: nowrap;"
                (click)="downloadFile()" matTooltip="Export selected as excel">
                <i class="bi bi-file-earmark-arrow-up"></i>
              </button> -->

              <!-- <button style="text-wrap: nowrap;" [disabled]="buttonState()"
                class="btn btn-outline-primary ms-1 py-1 px-2" matTooltip="List"
                *ngIf="isLogin && keyWordType != 'list' &&  (activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question')"
                [matMenuTriggerFor]="listMenu">
                Add to List <i class="mt-1 bi bi-chevron-down me-1"></i>
              </button> -->

              <div class="btn-group ms-1" role="group" aria-label="Basic example">
                <button class="btn btn-outline-primary py-1 px-2 text-nowrap" [disabled]="buttonState()"
                  [matMenuTriggerFor]="listMenu" matTooltip="Add To list"
                  *ngIf="isLogin && (activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question') && keyWordType!=='list'">
                  Add to List
                </button>
                <button class="btn btn-outline-primary py-1 px-2" [disabled]="buttonState()"
                  ngbPopover="Analyse Intent keywords" popoverClass="{{popover}}" container="body"
                  triggers="mouseenter:mouseleave"
                  *ngIf="keyWordType != 'list' && isLogin && (activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question')"
                  [matMenuTriggerFor]="listMenu">
                  <i class="mt-1 bi bi-chevron-down me-1"></i>
                </button>
              </div>

              <!-- <button *ngIf="activateLink =='Cluster'"
                  class="btn btn-outline-primary ml-auto ms-1 py-2 px-3 text-nowrap" style="white-space: nowrap;"
                  matTooltip="Export Cluster as excel">
                  <i class="bi bi-file-earmark-arrow-up me-1"></i>Export Cluster
                </button> -->
            </div>
          </div>
        </div>

        <!-- TABLE -->
        <div class="mt-3 rounded-3 ms-4 me-3"
          [ngClass]="activateLink!=='Settings' && theme ? 'border border-gray' : ''">
          <table class="hover p-4 m-0" [ngClass]="theme ? 'table bg-white' : 'table table-dark dark-table'"
            *ngIf="activateLink!=='Settings'">
            <thead>
              <tr class="table-content" [ngClass]="theme ? 'bg-white': 'dark-bg'">
                <th scope="col" class="text-secondary ps-3" style="width: 40px;"><input class="form-check-input"
                    type="button" placement="bottom" [ngbPopover]="SelectKeywords" popoverClass="{{popover}}"
                    role="button" container="body" *ngIf="activateLink !== 'clusters'"></th>
                <!-- <th scope="col" class="text-secondary ps-3" style="width: 40px;"><input class="form-check-input"
                      type="checkbox" (change)="CheckAll()" [(ngModel)]="masterSelected" role="button"
                      *ngIf="activateLink !== 'Cluster'"></th> -->
                <!-- <th scope="col" class="text-secondary"></th> -->
                <th scope="col" class="text-secondary text-center" style="width:360px;"
                  *ngIf="activateLink == 'all' || activateLink == 'hidden'">Keywords
                </th>
                <th scope="col" class="text-secondary text-center" style="width:360px;"
                  *ngIf="activateLink == 'suggestion'">
                  Suggestions</th>
                <th scope="col" class="text-secondary text-center" style="width:360px;"
                  *ngIf="activateLink == 'question'">Questions
                </th>
                <th scope="col" class="text-secondary text-center" *ngIf="activateLink == 'paa'">PAA</th>
                <th scope="col" class="text-secondary text-center" *ngIf="activateLink == 'related_search'">Related
                  Searches</th>
                <th scope="col" class="text-secondary text-start" *ngIf="activateLink == 'competition'">Domains</th>
                <th scope="col" class="text-secondary text-center" *ngIf="activateLink == 'clusters'">Clusters</th>
                <th scope="col" class="text-secondary text-center"
                  *ngIf="activateLink == 'paa' || activateLink == 'related_search'">Keyword</th>
                <th scope="col" class="text-secondary text-center" style="width:60px"
                  *ngIf="activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question' || activateLink == 'hidden' || activateLink==='clusters'">
                  <div class="d-flex align-items-center justify-content-center" role="button"
                    (click)="sortTable('vol')">
                    <i class="bi bi-arrow-up" *ngIf="volUparrow"></i>
                    <i class="bi bi-arrow-down" *ngIf="volDownarrow"></i>
                    <p class="m-0 me-2" triggers="mouseenter:mouseleave" [ngbPopover]="vol" popoverClass="{{popover}}"
                      container="body"> Vol. </p>
                    <ng-template #vol>
                      <div>
                        Estimated search volume per month in chosen location
                      </div>
                    </ng-template>
                  </div>
                </th>
                <th scope="col" class="text-center text-secondary" *ngIf="activateLink==='clusters'">
                  <div class="d-flex align-items-center justify-content-center" role="button"
                    (click)="sortTable('totalKeyword')">
                    <i class="bi bi-arrow-up" *ngIf="totalKeywordUpArrow"></i>
                    <i class="bi bi-arrow-down" *ngIf="totalKeywordDownArrow"></i>
                    <p class="m-0 me-2" [ngbPopover]="totalKeyword" popoverClass="{{popover}}" container="body"> Total
                      Keywords </p>
                    <ng-template #totalKeyword>
                      <div>
                        This shows the total number of keyword within a specific cluster
                      </div>
                    </ng-template>
                  </div>
                </th>
                <th scope="col" class="text-center text-secondary" *ngIf="activateLink==='clusters'">
                  <div class="d-flex align-items-center justify-content-center" role="button"
                    (click)="sortTable('weakKeyword')">
                    <i class="bi bi-arrow-up" *ngIf="weakKeywordUpArrow"></i>
                    <i class="bi bi-arrow-down" *ngIf="weakKeywordDownArrow"></i>
                    <p class="m-0 me-2" [ngbPopover]="weakKeyword" popoverClass="{{popover}}" container="body"> Weak
                      Keywords </p>
                    <ng-template #weakKeyword>
                      <div>
                        This shows the total number of keywords within a specific keyword cluster
                      </div>
                    </ng-template>
                  </div>
                </th>
                <th scope="col" class="text-secondary text-center" style="width:100px"
                  *ngIf="activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question' || activateLink == 'hidden'">
                  <div class="d-flex justify-content-center" role="button" (click)="sortTable('weakSpot')">
                    <i class="bi bi-arrow-up" *ngIf="weakSpotUpArrow"></i>
                    <i class="bi bi-arrow-down" *ngIf="weakSpotDownArrow"></i>
                    <p class="m-0 me-2">Score</p>
                    <!-- <i class="bi bi-exclamation-circle-fill"  matTooltip="The SERP Score shows the number of easy to outrank sites for a particular keyword. Higher
                      the number, better it is"  matTooltipClass="{{theme ? 'custom-tooltip' : ''}}"></i> -->
                    <i class="bi bi-exclamation-circle-fill" triggers="mouseenter:mouseleave" [ngbPopover]="serpScore"
                      popoverClass="{{popover}}" container="body"></i>
                  </div>
                  <ng-template #serpScore>
                    <div class="d-flex align-items-center mb-2 serp-score">
                      <p>The SERP Score shows the number of easy to outrank sites for a particular keyword. Higher
                        the number, better it is.</p>
                    </div>
                  </ng-template>
                </th>
                <th scope="col" class="text-secondary text-center"
                  *ngIf="activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question' || activateLink == 'hidden'">
                  <div class="d-flex justify-content-center align-items-center" role="button"
                    (click)="sortTable('serp')">
                    <i class="bi bi-arrow-up" *ngIf="serpUpArrow"></i>
                    <i class="bi bi-arrow-down" *ngIf="serpDownArrow"></i>
                    <p class="m-0 me-2">SERP Analysis</p>
                    <i class="bi bi-exclamation-circle-fill" triggers="mouseenter:mouseleave"
                      [ngbPopover]="serpAnalysis" popoverClass="{{popover}} custom-bottom" container="body"></i>
                  </div>
                  <ng-template #serpAnalysis>
                    <div class=" align-items-center">
                      <h5 class="mb-0 pr-1 heading">Identify SERP Weaknesses:</h5>
                      <p class="mb-2">Spot competitors that can be outperformed in the top 10, such as low DA sites,
                        Quora, Reddit, forums, and specified custom sites.</p>
                    </div>
                    <div class="d-flex align-items-center mb-2">
                      <div class="color-image rounded-circle" style="margin-bottom: -4px;">
                      </div>
                      <p class="m-0 ms-2">Low authority website</p>
                    </div>

                    <div class="d-flex align-items-center mb-2">
                      <div class="">
                        <img src="../../../assets/images/Vector.svg" role="button" triggers="mouseenter:mouseleave"
                          alt="" height="20" width="20">
                      </div>
                      <p class="m-0 ms-2">It represents Quora at a particular position</p>
                    </div>

                    <div class="d-flex align-items-center mb-2">
                      <div class="image rounded d-flex">
                        <img src="../../assets/images/Serp logo.svg" alt="" height="20" width="20">
                      </div>
                      <p class="m-0 ms-2">It represents Reddit at a particular position</p>
                    </div>

                    <div class="d-flex align-items-center">
                      <div class="">
                        <img src="../../../assets/images/comments-alt.svg" alt="" height="20" width="20">
                      </div>
                      <p class="m-0 ms-2">It represents Forum at a particular position</p>
                    </div>
                  </ng-template>
                </th>
                <th scope="col" class="text-secondary text-center"
                  *ngIf="activateLink == 'all' ||  activateLink == 'suggestion' || activateLink == 'question' || activateLink == 'hidden'">
                  <div class="d-flex justify-content-center align-items-center" role="button"
                    (click)="sortTable('cpc')">
                    <i class="bi bi-arrow-up" *ngIf="cpcUpArrow"></i>
                    <i class="bi bi-arrow-down" *ngIf="cpcDownArrow"></i>
                    <p class="m-0 me-2">CPC</p>
                  </div>
                </th>
                <th scope="col" class="text-secondary text-center"
                  *ngIf="(activateLink == 'all' ||  activateLink == 'suggestion' || activateLink == 'question' || activateLink == 'hidden') && waiting8MinutesArray.length > 1">
                  <button style="background: transparent;border: 0px;"><mat-icon style="
                        color: #0783d2;" (click)="performSerpExtract([],'','retryAll')">autorenew</mat-icon></button>
                </th>

                <th scope="col" class="text-secondary text-center" style="width: 50px;"
                  *ngIf="activateLink == 'all' ||  activateLink == 'suggestion' || activateLink == 'question' || activateLink == 'hidden'">
                  <div class="d-flex justify-content-center align-items-center" role="button"
                    (click)="sortTable('lda')">
                    <i class="bi bi-arrow-up" *ngIf="ldaUpArrow"></i>
                    <i class="bi bi-arrow-down" *ngIf="ldaDownArrow"></i>
                    <p class="m-0 me-2">L.DA</p>
                    <!-- <i class="bi bi-exclamation-circle-fill" 
                              matTooltip="Lowest DA in top 10 SERP Results"  matTooltipClass="{{theme ? 'custom-tooltip' : ''}}"></i> -->
                    <i class="bi bi-exclamation-circle-fill" triggers="mouseenter:mouseleave" [ngbPopover]="lowdaDesc"
                      popoverClass="{{customPopover}} custom" container="body"></i>
                  </div>
                  <!-- <i class="bi bi-exclamation-circle-fill" triggers="mouseenter:mouseleave"
                      ></i> -->
                  <ng-template class='customize' #lowdaDesc>
                    <div class="left-scores">
                      <p class="mb-0">Lowest DA in top 10 SERP Results.</p>
                    </div>
                  </ng-template>
                </th>
                <th scope="col" class="text-secondary text-center" style="width: 50px;" *ngIf="keyWordType == 'list'">

                </th>
              </tr>
            </thead>
            <tbody class="table-body">
              <!-- <ng-container > -->
              <ng-container
                *ngIf="activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question' || activateLink == 'hidden'  || keyWordType !== 'list'">
                <tr class="tr-cls" *ngFor="let data of paginateData;let i = index"
                  [ngClass]="{'bg-light-blue' : data.isChecked,'isRunning':data.status == 'R' || ids.includes(data.id)}">
                  <!-- <tr *ngFor="let data of paginateData  let i = index" [ngClass]="{'bg-light-blue' : data.isChecked}"> -->
                  <ng-container
                    *ngIf="activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question' || activateLink == 'hidden'">
                    <td class="ps-3">
                      <!-- <button class="btn" (click)="collapse.toggle()" [attr.aria-expanded]="!data.isShow"
                          aria-controls="collapseExample">Toggle me</button> -->
                      <input class="form-check-input" type="checkbox" [(ngModel)]="data.isChecked"
                        (change)="isAllSelected()" role="button"
                        [disabled]="!!ids.includes(data.id) || data.status == 'R'">
                    </td>
                    <!-- <td>
                          <i class="" (click)="changeColor(i)" role="button"
                            [ngClass]="data.isColorChanged ? 'icon-green bi bi-bookmark-fill' : 'bi bi-bookmark'"></i>
                        </td> -->
                    <td>
                      <ng-container
                        *ngIf="activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question' || activateLink == 'hidden'">
                        <div class="align-items-center d-flex">
                          <p class="m-0 pb-1"><span
                              [ngClass]="{'text-yellow' : data.isPaa,'text-orange' : data.isRelated}">{{showKey(data)}}
                            </span>
                            {{data.keyword}} <span
                              *ngIf="keyWordType != 'list' && saveListKeywordAry.includes(data.keyword)"><i
                                class="bi bi-bookmark-plus-fill"></i></span> </p>
                          <span style="height: 24px; width: 24px;">
                            <div class="d-flex" id="div{{i}}">
                              <div class="rounded-3 pt-1 ps-1 ms-2 copy-icon">
                                <mat-icon class="fs-5" role="button" [cdkCopyToClipboard]="data.keyword"
                                  ngbPopover="Copy" triggers="mouseenter:mouseleave" popoverClass="{{popover}}"
                                  placement="bottom"
                                  (click)="_snackBar.open('Copied to clipboard','',{duration:3000});">file_copy</mat-icon>
                              </div>
                              <div class="rounded-3 pt-1 p-1 ms-2 copy-icon" role="button">
                                <a class="text-decoration-none  pe-25 pe-3"
                                  [ngClass]="theme ? 'text-dark' : 'text-light'" role="button"
                                  [class.disabled]="data?.serpPosition?.length===0" #popover="ngbPopover"
                                  (click)="cutrrentPop=popover" (mouseenter)="popover.open(); popover.close();"
                                  [popoverClass]="theme ? 'right-pop1' : 'right-pop'"
                                  [ngbPopover]="data?.serpPosition?.length>0 ? popContent : ''" container="body">
                                  <i class="bi bi-google"></i></a>
                              </div>
                              <div class="rounded-3 pt-1 p-1 ms-2 copy-icon" role="button" ngbPopover="Open in New Tab"
                                triggers="mouseenter:mouseleave" popoverClass="{{popover}}" placement="bottom">
                                <a target="_blank" [ngClass]="theme ? 'text-dark' : 'text-light'"
                                  href="{{data.google_url}}" class="text-decoration-none"><i
                                    class="bi bi-arrow-up-right"></i></a>
                              </div>
                            </div>
                          </span>
                        </div>
                      </ng-container>
                    </td>
                    <ng-container
                      *ngIf="activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question' || activateLink == 'hidden'">
                      <td class="text-center">
                        <span>{{data.volume ? (data.volume==0 || data.volume==null) ?
                          '&lt;10' : data.volume : '&lt;10'}}</span>
                        <ng-template #loading>
                          <div class="spinner-border text-primary ms-2" role="status"></div>
                        </ng-template>
                      </td>
                      <td>
                        <div class="d-flex justify-content-center"
                          *ngIf="data?.serpPosition && data?.serpPosition[0]?.position && (data.status !=='R' && !ids.includes(data.id))">
                          <div class="text-center rounded rounded-5 weakspot-count "
                            [ngClass]="{'text-white bg-secondary' : (data.serp_score_count >= 0 && data.serp_score_count <= 2),'bg-warning' : (data.serp_score_count >=3 && data.serp_score_count < 4),'bg-success text-light' : (data.serp_score_count >=4)}">
                            <span *ngIf="data?.serpPosition && data?.serpPosition[0]?.position">{{data.serp_score_count
                              ?
                              data.serp_score_count > 10 ? 10 : data.serp_score_count
                              : 0}}</span>
                          </div>
                        </div>

                      </td>
                      <!-- <td class="text-center"><i class="bi bi-file-earmark-text"></i></td>
                            <td class="w-10"><i class="bi bi-arrow-repeat"></i></td> -->
                      <td *ngIf="(data.status !=='R' && !ids.includes(data.id));else loadingArea">
                        <div class="d-flex col-12 align-items-center justify-content-center"
                          style=" margin-left: -8px;">
                          <div class="d-flex align-items-center" *ngFor="let position of data.serpPosition">
                            <span class="mx-1">{{position.position}}</span>
                            <div *ngFor="let serp of position?.serp" [ngSwitch]="serp?.key">
                              <ng-container *ngSwitchCase="'all false'">
                                <ng-container *ngIf="!position.isCustomDomain && !position.isMySites">
                                  <div class="no-image" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="position.isCustomDomain && !position.isMySites">
                                  <div class="purple-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="!position.isCustomDomain && position.isMySites">
                                  <div class="blue-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="position.isCustomDomain && position.isMySites">
                                  <div class="d-flex">
                                    <div class="purple-weak-spot me-1" role="button" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                    </div>
                                    <div class="blue-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                    </div>
                                  </div>
                                </ng-container>
                              </ng-container>
                              <ng-container *ngSwitchCase="'web 2.0'">
                                <ng-container *ngIf="!position.isCustomDomain && !position.isMySites">
                                  <div class="no-image" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="position.isCustomDomain && !position.isMySites">
                                  <div class="purple-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="!position.isCustomDomain && position.isMySites">
                                  <div class="blue-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="position.isCustomDomain && position.isMySites">
                                  <div class="d-flex">
                                    <div class="purple-weak-spot me-1" role="button" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                    </div>
                                    <div class="blue-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                    </div>
                                  </div>
                                </ng-container>
                              </ng-container>
                              <ng-container *ngSwitchCase="'socialmedia'">
                                <ng-container *ngIf="!position.isCustomDomain && !position.isMySites">
                                  <div class="no-image" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="position.isCustomDomain && !position.isMySites">
                                  <div class="purple-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="!position.isCustomDomain && position.isMySites">
                                  <div class="blue-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="position.isCustomDomain && position.isMySites">
                                  <div class="d-flex">
                                    <div class="purple-weak-spot me-1" role="button" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                    </div>
                                    <div class="blue-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                    </div>
                                  </div>
                                </ng-container>
                              </ng-container>
                              <ng-container *ngSwitchCase="'filetype'">
                                <ng-container *ngIf="!position.isCustomDomain && !position.isMySites">
                                  <div class="no-image" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="position.isCustomDomain && !position.isMySites">
                                  <div class="purple-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="!position.isCustomDomain && position.isMySites">
                                  <div class="blue-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="position.isCustomDomain && position.isMySites">
                                  <div class="d-flex">
                                    <div class="purple-weak-spot me-1" role="button" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                    </div>
                                    <div class="blue-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                    </div>
                                  </div>
                                </ng-container>
                              </ng-container>
                              <ng-container *ngSwitchCase="'quora'">
                                <ng-container *ngIf="!position.isCustomDomain && !position.isMySites">
                                  <img src="../../../assets/images/Vector.svg" role="button"
                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1" alt="" height="20"
                                    width="20" popoverClass="{{popover}}" placement="top">
                                </ng-container>
                                <ng-container *ngIf="position.isCustomDomain && !position.isMySites">
                                  <div class="purple-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}" placement="top">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="!position.isCustomDomain && position.isMySites">
                                  <div class="blue-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="position.isCustomDomain && position.isMySites">
                                  <div class="d-flex">
                                    <div class="purple-weak-spot me-1" role="button" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                    </div>
                                    <div class="blue-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                    </div>
                                  </div>
                                </ng-container>
                              </ng-container>
                              <ng-container *ngSwitchCase="'reddit'">
                                <ng-container *ngIf="!position.isCustomDomain && !position.isMySites">
                                  <img src="../../../assets/images/Serp logo.svg" role="button"
                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1" alt="" height="20"
                                    width="20" popoverClass="{{popover}}">
                                </ng-container>

                                <ng-container *ngIf="position.isCustomDomain && !position.isMySites">
                                  <div class="purple-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="!position.isCustomDomain && position.isMySites">
                                  <div class="blue-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="position.isCustomDomain && position.isMySites">
                                  <div class="d-flex">
                                    <div class="purple-weak-spot me-1" role="button" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                    </div>
                                    <div class="blue-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                    </div>
                                  </div>
                                </ng-container>
                              </ng-container>
                              <ng-container *ngSwitchCase="'lowda'">
                                <ng-container *ngIf="!position.isCustomDomain && !position.isMySites">
                                  <div
                                    [ngClass]="serp?.da?.da <=settingsData?.maxDa ? 'color-image rounded-circle text-light' : 'rounded no-image'"
                                    role="button" triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                    popoverClass="{{popover}}" container="body">
                                    {{serp?.da?.da <=settingsData?.maxDa ? serp?.da?.da : '' }} </div>
                                </ng-container>
                                <ng-container *ngIf="position.isCustomDomain && !position.isMySites">
                                  <div class="purple-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="!position.isCustomDomain && position.isMySites">
                                  <div class="blue-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="position.isCustomDomain && position.isMySites">
                                  <div class="d-flex">
                                    <div class="purple-weak-spot me-1" role="button" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                    </div>
                                    <div class="blue-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                    </div>
                                  </div>
                                </ng-container>
                              </ng-container>
                              <ng-container *ngSwitchCase="'forum'">
                                <ng-container *ngIf="!position.isCustomDomain && !position.isMySites">
                                  <img src="../../../assets/images/comments-alt.svg" role="button"
                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                    popoverClass="{{popover}}" alt="" height="20" width="20">
                                </ng-container>
                                <ng-container *ngIf="position.isCustomDomain && !position.isMySites">
                                  <div class="purple-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="!position.isCustomDomain && position.isMySites">
                                  <div class="blue-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                    [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="position.isCustomDomain && position.isMySites">
                                  <div class="d-flex">
                                    <div class="purple-weak-spot me-1" role="button" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                    </div>
                                    <div class="blue-weak-spot" role="button" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                    </div>
                                  </div>
                                </ng-container>
                              </ng-container>
                              <ng-template #popContent1>
                                <div *ngIf="!!serp?.da && !!serp?.da?.da;else normalDomain">
                                  <p><b>Position:</b> {{position.position}}</p>
                                  <p><b>DA:</b> {{serp.da.da}}</p>
                                  <!-- <p><b>Semrush Organic Keywords:</b> {{serp?.da?.sr_kwords}}</p>
                                  <p><b>Semrush Traffic for month:</b> {{serp?.da?.sr_traffic}}</p>
                                  <p><b>Semrush Domain links:</b> {{serp?.da?.sr_dlinks}}</p> -->
                                  <span><b>URL:</b></span><a href=""
                                    [ngClass]="theme ? 'text-white' : 'text-decoration-none text-light'">
                                    {{position.domain}}
                                  </a>
                                </div>
                                <ng-template #normalDomain>
                                  <div class="">
                                    <a href="" [ngClass]="theme ? 'text-white' : 'text-decoration-none text-light'"
                                      class="heading">
                                      {{position.domain}}
                                    </a>
                                  </div>
                                </ng-template>
                              </ng-template>
                            </div>
                            <div class="mx-1 d-flex">
                            </div>
                          </div>
                        </div>
                      </td>
                      <td style="text-align: center">
                        <span *ngIf="(!!data?.cpc && data?.cpc!==null);else optionForCPC">${{data?.cpc}}</span>
                        <ng-template #optionForCPC>
                          <span>-</span>
                        </ng-template>
                      </td>
                      <!-- <span *ngIf="!waiting8MinutesArray.includes(data.title);else RetryArea"></span> -->
                      <td style="text-align: center">
                        {{ data?.lda <= settingsData.maxDa ? data?.lda===null ? "-" : data?.lda : "-" }}</td>
                      <td *ngIf="keyWordType == 'list'" style="text-align: center;cursor:pointer"
                        (click)="deleteListKeyword(data.id)">
                        <i class="bi bi-trash-fill"></i>
                      </td>
                      <!-- <td style="text-align: center">
                            {{ data?.HDA <= settingsData.maxDa ? data?.HDA===null ? "-" : data?.HDA : "-" }}</td> -->
                      <ng-template #loadingArea>
                        <td style="text-align: center;position: relative;">
                          <!-- <div class="d-flex justify-content-center align-items-center">
                            <div class="spinner-border text-primary" role="status"></div>
                          </div> -->
                          <div class="d-flex justify-content-center align-items-center">
                            <!-- <div class="containerr" style="position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);">
                              <div class="progresss progress-infinite">
                                <div class="progress-bar3">
                                </div>
                              </div>
                            </div> -->
                            Analyzing....
                          </div>
                        </td>
                      </ng-template>
                      <!-- <ng-template #RetryArea  >
                            <td>
                              <div class="d-flex align-items-center">
                              </div>
                            </td>
                            <td>
                              <div class="d-flex align-items-center">
                              </div>
                            </td>
                            <td *ngIf="waiting8MinutesArray.includes(data.title)">
                              <div class="d-flex align-items-center">
                              </div>
                            </td>
                            <td *ngIf="waiting8MinutesArray.includes(data.title)">
                              <div class="d-flex align-items-center">
                                <button style="background: transparent;border: 0px;" (click)="performSerpExtract([],data.title)" ><mat-icon style="
                                  color: #0783d2;" >autorenew</mat-icon></button>
                              </div>
                            </td>
                          </ng-template> -->
                    </ng-container>

                    <ng-template #popContent>
                      <div class="" (mouseleave)="closePop(i)">
                        <table class="table " [ngClass]="theme ? 'srtp': 'dark-pop-table'">
                          <!-- <thead>
                            <tr class="table-content">
                              <th scope="col" class="text-secondary"></th>
                              <th scope="col" class="text-secondary"></th>
                              <th scope="col" class="text-secondary"></th>
                            </tr>
                          </thead> -->
                          <tbody class="table-body">
                            <tr *ngFor="let elements of data?.serpPosition">
                              <div class="srps-content">
                                <td class="align-middle">{{elements.position}}</td>
                                <td class="align-middle">
                                  <ng-container
                                    *ngIf="(!!elements?.isCustomDomain || !!elements.isMySites);then customSerp;else remainingSerp"></ng-container>
                                  <ng-template #customSerp>
                                    <ng-container *ngIf="!!elements?.isCustomDomain && !elements.isMySites">
                                      <div class="purple-weak-spot" role="button">
                                      </div>
                                    </ng-container>
                                    <ng-container *ngIf="!elements?.isCustomDomain && !!elements.isMySites">
                                      <div class="blue-weak-spot" role="button">
                                      </div>
                                    </ng-container>
                                    <ng-container *ngIf="!!elements.isCustomDomain && !!elements.isMySites">
                                      <div class="">
                                        <div class="purple-weak-spot" role="button">
                                        </div>
                                        <div class="blue-weak-spot mt-1" role="button">
                                        </div>
                                      </div>
                                    </ng-container>
                                  </ng-template>
                                  <ng-template #remainingSerp>
                                    <div *ngFor="let serp of elements?.serp">
                                      <div class="" *ngIf="serp?.key==='quora'">
                                        <ng-container *ngIf="!serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                          <img src="../../../assets/images/Vector.svg" role="button"
                                            triggers="mouseenter:mouseleave" alt="" height="20" width="20">
                                        </ng-container>
                                        <ng-container *ngIf="serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                          <div class="purple-weak-spot" role="button">
                                          </div>
                                        </ng-container>
                                        <ng-container *ngIf="!serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                          <div class="blue-weak-spot" role="button">
                                          </div>
                                        </ng-container>
                                        <ng-container *ngIf="serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                          <div class="purple-weak-spot" role="button">
                                          </div>
                                          <div class="blue-weak-spot" role="button">
                                          </div>
                                        </ng-container>
                                      </div>
                                      <div class="" *ngIf="serp?.key==='reddit'">
                                        <ng-container *ngIf="!serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                          <img src="../../assets/images/Serp logo.svg" alt="" height="20" width="20">
                                        </ng-container>
                                        <ng-container *ngIf="serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                          <div class="purple-weak-spot" role="button">
                                          </div>
                                        </ng-container>
                                        <ng-container *ngIf="!serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                          <div class="blue-weak-spot" role="button">
                                          </div>
                                        </ng-container>
                                        <ng-container *ngIf="serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                          <div class="purple-weak-spot" role="button">
                                          </div>
                                          <div class="blue-weak-spot" role="button">
                                          </div>
                                        </ng-container>
                                      </div>
                                      <ng-container
                                        *ngIf="serp?.key==='all false' || serp?.key==='web 2.0' || serp?.key==='socialmedia' || serp?.key==='filetype'">
                                        <ng-container>
                                          <div class="no-image" role="button">
                                          </div>
                                        </ng-container>
                                        <!-- <ng-container
                                        *ngIf="serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                        <div class="purple-weak-spot" role="button">
                                        </div>
                                      </ng-container>
                                      <ng-container
                                        *ngIf="!serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                        <div class="blue-weak-spot" role="button">
                                        </div>
                                      </ng-container>
                                      <ng-container
                                        *ngIf="serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                        <div class="purple-weak-spot" role="button">
                                        </div>
                                        <div class="blue-weak-spot" role="button">
                                        </div>
                                      </ng-container> -->
                                      </ng-container>
                                      <ng-container *ngIf="serp?.key==='lowda'">
                                        <ng-container *ngIf="!serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                          <div
                                            [ngClass]="serp?.da?.da <=settingsData?.maxDa ? 'color-image rounded-circle text-light' : 'no-image'">
                                            {{serp?.da?.da <=settingsData?.maxDa ? serp?.da?.da : '' }} </div>
                                        </ng-container>
                                        <ng-container *ngIf="serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                          <div class="purple-weak-spot" role="button">
                                          </div>
                                        </ng-container>
                                        <ng-container *ngIf="!serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                          <div class="blue-weak-spot" role="button">
                                          </div>
                                        </ng-container>
                                        <ng-container *ngIf="serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                          <div class="purple-weak-spot" role="button">
                                          </div>
                                          <div class="blue-weak-spot" role="button">
                                          </div>
                                        </ng-container>
                                      </ng-container>
                                      <div class="" *ngIf="serp?.key==='forum'">
                                        <ng-container *ngIf="!serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                          <img src="../../../assets/images/comments-alt.svg" alt="" height="20"
                                            width="20">
                                        </ng-container>
                                        <ng-container *ngIf="serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                          <div class="purple-weak-spot" role="button">
                                          </div>
                                        </ng-container>
                                        <ng-container *ngIf="!serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                          <div class="blue-weak-spot" role="button">
                                          </div>
                                        </ng-container>
                                        <ng-container *ngIf="serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                          <div class="purple-weak-spot" role="button">
                                          </div>
                                          <div class="blue-weak-spot" role="button">
                                          </div>
                                        </ng-container>
                                      </div>
                                    </div>
                                  </ng-template>
                                </td>
                                <td>
                                  <div class="w-500 ps-2">
                                    <p class="m-0 p-0 heading">{{elements?.title}}</p>
                                    <a target="_blank" href="{{elements?.link}}"
                                      class="text-decoration-none fw-600 overflow-ellipsis">
                                      {{elements?.link}}
                                    </a>
                                  </div>
                                </td>
                              </div>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                    </ng-template>
                  </ng-container>
                </tr>
              </ng-container>
              <ng-container *ngIf="activateLink == 'paa' || activateLink == 'related_search'">
                <tr class="tr-cls" *ngFor="let data of paginateData;let i = index"
                  [ngClass]="{'bg-light-blue' : data.isChecked}">
                  <td class="ps-3">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="data.isChecked"
                      (change)="isAllSelected()" role="button">
                  </td>
                  <td>
                    <div class="align-items-center d-flex">
                      <p class="m-0 pb-1"><span
                          [ngClass]="{'text-yellow' : activateLink == 'paa','text-orange' : activateLink == 'related_search'}">{{showKey(data)}}
                        </span>
                        {{data.text}} </p>
                      <span style="height: 24px; width: 24px;">
                        <div class="d-flex" id="div{{i}}">
                          <div class="rounded-3 pt-1 ps-1 ms-2 copy-icon">
                            <mat-icon class="fs-5" role="button" [cdkCopyToClipboard]="data.keyword.keyword"
                              ngbPopover="Copy" triggers="mouseenter:mouseleave" popoverClass="{{popover}}"
                              placement="bottom"
                              (click)="_snackBar.open('Copied to clipboard','',{duration:3000});">file_copy</mat-icon>
                          </div>
                          <div class="rounded-3 pt-1 p-1 ms-2 copy-icon" role="button" ngbPopover="Open in New Tab"
                            triggers="mouseenter:mouseleave" popoverClass="{{popover}}" placement="bottom">
                            <a target="_blank" [ngClass]="theme ? 'text-dark' : 'text-light'"
                              href="{{data?.keyword?.google_url}}" class="text-decoration-none"><i
                                class="bi bi-arrow-up-right"></i></a>
                          </div>
                        </div>
                      </span>
                    </div>
                  </td>
                  <td>
                    {{data?.keyword.keyword}}</td>
                </tr>
              </ng-container>
              <ng-container *ngIf="activateLink == 'competition'">
                <tr class="tr-cls" *ngFor="let data of paginateData;let i = index"
                  [ngClass]="{'bg-light-blue' : data.isChecked}">
                  <td class="ps-3">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="data.isChecked"
                      (change)="isAllSelected()" role="button">
                  </td>
                  <td>
                    <div class="align-items-center d-flex">
                      <p class="m-0 pb-1">
                        {{data.text.domain}} </p>
                      <div class="ms-2" *ngIf="data.text.lowda">
                        <span class="loading-span">Low Domain Authority
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-container>
              <ng-container *ngIf="activateLink=='clusters'">
                <ng-container *ngIf="paginateData.length===0">
                  <tr class="tr-cls">
                    <td colspan="12">No Clusters Available</td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="paginateData.length>0">
                  <ng-container *ngFor="let data of paginateData;let i = index">
                    <tr class="tr-cls" [ngClass]="{'bg-light-blue' : data?.isChecked}">
                      <th scope="row">
                        <button class="btn" (click)="collapseToggle(i)" [ngClass]="theme ? '' : 'text-white'"
                          [attr.aria-expanded]="!data?.isShow" aria-controls="collapseExample"><i
                            [ngClass]="!data?.isShow ? 'bi bi-plus' : 'bi bi-dash'"></i></button>
                      </th>
                      <td>
                        <div class="d-flex align-items-center">
                          <p class="m-0"><span
                              [ngClass]="{'text-yellow' : data?.isPaa,'text-orange' : data?.isRelated}">{{showKey(data)}}
                            </span>
                            {{data?.text?.highest_volume_keywords}}</p>
                        </div>
                      </td>
                      <td class="text-center">
                        <span>{{data?.text?.total_volume ? data?.text?.total_volume :
                          0}}</span>
                      </td>
                      <td class="text-center">{{data?.text?.total_keywords ? data?.text?.total_keywords : 0}}</td>
                      <td class="text-center">{{data?.text?.total_weak_spots}}</td>
                    </tr>
                    <tr [(ngbCollapse)]="!data.isShow">
                      <td class="md" colspan="12">
                        <div class="">
                          <table class="table m-0">
                            <thead>
                              <tr class="table-content cgColor">
                                <th scope="col" class="text-secondary text-center" style="width: 30px;"></th>
                                <th scope="col" class="text-secondary text-center" style="width: 330px;">Keyword</th>
                                <th scope="col" class="text-secondary text-center" style="width:150px">
                                  <div class="d-flex align-items-center justify-content-center" role="button"
                                    (click)="sortCluster('vol',i)">
                                    <i class="bi bi-arrow-up" *ngIf="data?.volUparrow"></i>
                                    <i class="bi bi-arrow-down" *ngIf="data?.volDownarrow"></i>
                                    <p class="m-0 me-2"> Vol. </p>
                                  </div>
                                </th>
                                <th scope="col" class="text-secondary text-center" style="width:150px">
                                  <div class="d-flex justify-content-center" role="button"
                                    (click)="sortCluster('weakSpot',i)">
                                    <i class="bi bi-arrow-up" *ngIf="data?.weakSpotUpArrow"></i>
                                    <i class="bi bi-arrow-down" *ngIf="data?.weakSpotDownArrow"></i>
                                    <p class="m-0 me-2">SERP Score</p>
                                    <i class="bi bi-exclamation-circle-fill" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="serpScore" popoverClass="{{popover}}"></i>
                                  </div>
                                  <ng-template #serpScore>
                                    <div class="d-flex align-items-center mb-2 serp-score">
                                      <p>The SERP Score shows the number of easy to outrank sites for a particular
                                        keyword. Higher
                                        the number, better it is.</p>
                                    </div>
                                  </ng-template>
                                </th>
                                <th scope="col" class="text-secondary text-center" style="width: 700px;">
                                  <div class="d-flex justify-content-center align-items-center" role="button"
                                    (click)="sortCluster('serp',i)">
                                    <i class="bi bi-arrow-up" *ngIf="data?.serpUpArrow"></i>
                                    <i class="bi bi-arrow-down" *ngIf="data?.serpDownArrow"></i>
                                    <p class="m-0 me-2 text-center">SERP Analysis</p>
                                    <i class="bi bi-exclamation-circle-fill" triggers="mouseenter:mouseleave"
                                      [ngbPopover]="serpAnalysis" popoverClass="{{popover}} custom"
                                      container="body"></i>
                                  </div>
                                  <ng-template #serpAnalysis>

                                    <div class="d-flex align-items-center mb-2">
                                      <div class="color-image rounded-circle" style="margin-bottom: -4px;">
                                      </div>
                                      <p class="m-0 ms-2">Low authority website</p>
                                    </div>

                                    <div class="d-flex align-items-center mb-2">
                                      <div class="">
                                        <img src="../../../assets/images/Vector.svg" role="button"
                                          triggers="mouseenter:mouseleave" alt="" height="20" width="20">
                                      </div>
                                      <p class="m-0 ms-2">It represents Quora at a particular position</p>
                                    </div>

                                    <div class="d-flex align-items-center mb-2">
                                      <div class="image rounded d-flex">
                                        <img src="../../assets/images/Serp logo.svg" alt="" height="20" width="20">
                                      </div>
                                      <p class="m-0 ms-2">It represents Reddit at a particular position</p>
                                    </div>

                                    <div class="d-flex align-items-center">
                                      <div class="">
                                        <img src="../../../assets/images/comments-alt.svg" alt="" height="20"
                                          width="20">
                                      </div>
                                      <p class="m-0 ms-2">It represents Forum at a particular position</p>
                                    </div>
                                  </ng-template>
                                </th>
                                <th scope="col" class="text-secondary text-center" style="width: 100px;">
                                  <div class="d-flex justify-content-center align-items-center" role="button"
                                    (click)="sortCluster('cpc',i)">
                                    <i class="bi bi-arrow-up" *ngIf="data?.cpcUparrow"></i>
                                    <i class="bi bi-arrow-down" *ngIf="data?.cpcDownarrow"></i>
                                    <p class="m-0 me-2">CPC</p>
                                  </div>
                                </th>
                              </tr>
                            </thead>
                            <tbody class="table-body cgColor">
                              <ng-container *ngFor="let subData of data.text.keywords;let i = index;">
                                <tr class="subtr-cls" [ngClass]="{'bg-light-blue' : data.isChecked}">
                                  <ng-container>
                                    <ng-container>
                                      <td style="width: 30px;">
                                        <input class="form-check-input" type="checkbox"  [(ngModel)]="subData.isChecked" (change)="selectCluters(data.text.id)"
                                          role="button">
                                      </td>
                                      <td style="width: 330px;">
                                        <div class="d-flex justify-content-start">
                                          <p class="m-0 pb-1">
                                            {{subData.keyword}}</p>
                                          <span style="height: 24px; width: 24px;">
                                            <div class="d-flex">
                                              <div class="rounded-3 pt-1 ps-1 ms-2 copy-icon">
                                                <mat-icon class="fs-5" role="button"
                                                  [cdkCopyToClipboard]="subData.keyword" ngbPopover="Copy"
                                                  triggers="mouseenter:mouseleave" popoverClass="{{popover}}"
                                                  placement="bottom"
                                                  (click)="_snackBar.open('Copied to clipboard','',{duration:3000});">file_copy</mat-icon>
                                              </div>
                                              <div class="rounded-3 pt-1 p-1 ms-2 copy-icon" role="button">
                                                <a class="text-decoration-none  pe-25 pe-3"
                                                  [ngClass]="theme ? 'text-dark' : 'text-light'" role="button"
                                                  [class.disabled]="subData?.serpPosition?.length===0"
                                                  #popover="ngbPopover" (click)="cutrrentPop=popover"
                                                  (mouseenter)="popover.open(); popover.close();"
                                                  [popoverClass]="theme ? 'right-pop1' : 'right-pop'"
                                                  [ngbPopover]="subData?.serpPosition?.length>0 ? popContent : ''"
                                                  container="body">
                                                  <i class="bi bi-google"></i>
                                                </a>
                                              </div>
                                              <div class="rounded-3 pt-1 p-1 ms-2 copy-icon" role="button"
                                                ngbPopover="Open in New Tab" triggers="mouseenter:mouseleave"
                                                popoverClass="{{popover}}" placement="bottom">

                                                <a target="_blank" [ngClass]="theme ? 'text-dark' : 'text-light'"
                                                  href="{{subData.google_url}}" class="text-decoration-none"><i
                                                    class="bi bi-arrow-up-right"></i></a>
                                              </div>
                                            </div>
                                          </span>
                                        </div>
                                      </td>
                                      <td class="text-center" style="width:150px">
                                        <span *ngIf="subData?.serpPosition[0]?.position">{{subData.volume ?
                                          subData.volume
                                          : 0}}</span>
                                      </td>
                                      <td style="width:150px">
                                        <div class="d-flex justify-content-center">
                                          <div class="text-center rounded rounded-5 weakspot-count "
                                            [ngClass]="{'text-white bg-secondary' : (subData.serp_score_count >= 0 && subData.serp_score_count <= 2),'bg-warning' : (subData.serp_score_count >=3 && subData.serp_score_count < 4),'bg-success text-light' : (subData.serp_score_count >=4)}">
                                            <span
                                              *ngIf="subData?.serpPosition[0]?.position">{{subData.serp_score_count}}</span>
                                          </div>
                                        </div>
                                      </td>
                                      <td
                                        *ngIf="!(backupKeyWordArray.includes(data.title) || waiting8MinutesBackupArray.includes(data.title))" style="min-width: 700px;">
                                        <div class="d-flex col-12 justify-content-center align-items-center"
                                          style="margin-left: -8px;">
                                          <div class="d-flex align-items-center"
                                            *ngFor="let position of subData.serpPosition">
                                            <span class="mx-1">{{position.position}}</span>
                                            <div *ngFor="let serp of position.serp" [ngSwitch]="serp?.key">
                                              <ng-container *ngSwitchCase="'all false'">
                                                <ng-container *ngIf="!position.isCustomDomain && !position.isMySites">
                                                  <div class="no-image" role="button" triggers="mouseenter:mouseleave"
                                                    [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="position.isCustomDomain && !position.isMySites">
                                                  <div class="purple-weak-spot" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="!position.isCustomDomain && position.isMySites">
                                                  <div class="blue-weak-spot" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="position.isCustomDomain && position.isMySites">
                                                  <div class="d-flex">
                                                    <div class="purple-weak-spot me-1" role="button"
                                                      triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                      popoverClass="{{popover}}">
                                                    </div>
                                                    <div class="blue-weak-spot" role="button"
                                                      triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                      popoverClass="{{popover}}">
                                                    </div>
                                                  </div>
                                                </ng-container>
                                              </ng-container>
                                              <ng-container *ngSwitchCase="'web 2.0'">
                                                <ng-container *ngIf="!position.isCustomDomain && !position.isMySites">
                                                  <div class="no-image" role="button" triggers="mouseenter:mouseleave"
                                                    [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="position.isCustomDomain && !position.isMySites">
                                                  <div class="purple-weak-spot" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="!position.isCustomDomain && position.isMySites">
                                                  <div class="blue-weak-spot" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="position.isCustomDomain && position.isMySites">
                                                  <div class="d-flex">
                                                    <div class="purple-weak-spot me-1" role="button"
                                                      triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                      popoverClass="{{popover}}">
                                                    </div>
                                                    <div class="blue-weak-spot" role="button"
                                                      triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                      popoverClass="{{popover}}">
                                                    </div>
                                                  </div>
                                                </ng-container>
                                              </ng-container>
                                              <ng-container *ngSwitchCase="'socialmedia'">
                                                <ng-container *ngIf="!position.isCustomDomain && !position.isMySites">
                                                  <div class="no-image" role="button" triggers="mouseenter:mouseleave"
                                                    [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="position.isCustomDomain && !position.isMySites">
                                                  <div class="purple-weak-spot" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="!position.isCustomDomain && position.isMySites">
                                                  <div class="blue-weak-spot" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="position.isCustomDomain && position.isMySites">
                                                  <div class="d-flex">
                                                    <div class="purple-weak-spot me-1" role="button"
                                                      triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                      popoverClass="{{popover}}">
                                                    </div>
                                                    <div class="blue-weak-spot" role="button"
                                                      triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                      popoverClass="{{popover}}">
                                                    </div>
                                                  </div>
                                                </ng-container>
                                              </ng-container>
                                              <ng-container *ngSwitchCase="'filetype'">
                                                <ng-container *ngIf="!position.isCustomDomain && !position.isMySites">
                                                  <div class="no-image" role="button" triggers="mouseenter:mouseleave"
                                                    [ngbPopover]="popContent1" popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="position.isCustomDomain && !position.isMySites">
                                                  <div class="purple-weak-spot" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="!position.isCustomDomain && position.isMySites">
                                                  <div class="blue-weak-spot" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="position.isCustomDomain && position.isMySites">
                                                  <div class="d-flex">
                                                    <div class="purple-weak-spot me-1" role="button"
                                                      triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                      popoverClass="{{popover}}">
                                                    </div>
                                                    <div class="blue-weak-spot" role="button"
                                                      triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                      popoverClass="{{popover}}">
                                                    </div>
                                                  </div>
                                                </ng-container>
                                              </ng-container>
                                              <ng-container *ngSwitchCase="'quora'">
                                                <ng-container *ngIf="!position.isCustomDomain && !position.isMySites">
                                                  <img src="../../../assets/images/Vector.svg" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}" placement="top" alt="" height="20"
                                                    width="20">
                                                </ng-container>
                                                <ng-container *ngIf="position.isCustomDomain && !position.isMySites">
                                                  <div class="purple-weak-spot" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="!position.isCustomDomain && position.isMySites">
                                                  <div class="blue-weak-spot" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="position.isCustomDomain && position.isMySites">
                                                  <div class="d-flex">
                                                    <div class="purple-weak-spot me-1" role="button"
                                                      triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                      popoverClass="{{popover}}">
                                                    </div>
                                                    <div class="blue-weak-spot" role="button"
                                                      triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                      popoverClass="{{popover}}">
                                                    </div>
                                                  </div>
                                                </ng-container>
                                              </ng-container>
                                              <ng-container *ngSwitchCase="'reddit'">
                                                <ng-container *ngIf="!position.isCustomDomain && !position.isMySites">
                                                  <img class="reddit-img" src="../../../assets/images/Serp logo.svg"
                                                    role="button" triggers="mouseenter:mouseleave"
                                                    [ngbPopover]="popContent1" popoverClass="{{popover}}" alt="">
                                                </ng-container>

                                                <ng-container *ngIf="position.isCustomDomain && !position.isMySites">
                                                  <div class="purple-weak-spot" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="!position.isCustomDomain && position.isMySites">
                                                  <div class="blue-weak-spot" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="position.isCustomDomain && position.isMySites">
                                                  <div class="d-flex">
                                                    <div class="purple-weak-spot me-1" role="button"
                                                      triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                      popoverClass="{{popover}}">
                                                    </div>
                                                    <div class="blue-weak-spot" role="button"
                                                      triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                      popoverClass="{{popover}}">
                                                    </div>
                                                  </div>
                                                </ng-container>
                                              </ng-container>
                                              <ng-container *ngSwitchCase="'lowda'">
                                                <ng-container *ngIf="!position.isCustomDomain && !position.isMySites">
                                                  <div
                                                    [ngClass]="serp?.da?.da <=settingsData?.maxDa ? 'color-image rounded-circle text-light' : 'rounded no-image'"
                                                    role="button" triggers="mouseenter:mouseleave"
                                                    [ngbPopover]="popContent1" popoverClass="{{popover}}"
                                                    container="body">
                                                    {{serp?.da?.da <=settingsData?.maxDa ? serp?.da?.da : '' }} </div>
                                                </ng-container>
                                                <ng-container *ngIf="position.isCustomDomain && !position.isMySites">
                                                  <div class="purple-weak-spot" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="!position.isCustomDomain && position.isMySites">
                                                  <div class="blue-weak-spot" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="position.isCustomDomain && position.isMySites">
                                                  <div class="d-flex">
                                                    <div class="purple-weak-spot me-1" role="button"
                                                      triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                      popoverClass="{{popover}}">
                                                    </div>
                                                    <div class="blue-weak-spot" role="button"
                                                      triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                      popoverClass="{{popover}}">
                                                    </div>
                                                  </div>
                                                </ng-container>
                                              </ng-container>
                                              <ng-container *ngSwitchCase="'forum'">
                                                <ng-container *ngIf="!position.isCustomDomain && !position.isMySites">
                                                  <img src="../../../assets/images/comments-alt.svg" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}" alt="" height="20" width="20">
                                                </ng-container>
                                                <ng-container *ngIf="position.isCustomDomain && !position.isMySites">
                                                  <div class="purple-weak-spot" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="!position.isCustomDomain && position.isMySites">
                                                  <div class="blue-weak-spot" role="button"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                    popoverClass="{{popover}}">
                                                  </div>
                                                </ng-container>
                                                <ng-container *ngIf="position.isCustomDomain && position.isMySites">
                                                  <div class="d-flex">
                                                    <div class="purple-weak-spot me-1" role="button"
                                                      triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                      popoverClass="{{popover}}">
                                                    </div>
                                                    <div class="blue-weak-spot" role="button"
                                                      triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"
                                                      popoverClass="{{popover}}">
                                                    </div>
                                                  </div>
                                                </ng-container>
                                              </ng-container>
                                              <ng-template #popContent1>
                                                <div *ngIf="!!serp?.da && !!serp?.da?.da;else normalDomain">
                                                  <p><b>Position:</b> {{position.position}}</p>
                                                  <p><b>DA:</b> {{serp.da.da}}</p>
                                                  <!-- <p><b>Semrush Organic Keywords:</b> {{serp?.da?.sr_kwords}}</p>
                                                  <p><b>Semrush Traffic for month:</b> {{serp?.da?.sr_traffic}}</p>
                                                  <p><b>Semrush Domain links:</b> {{serp?.da?.sr_dlinks}}</p> -->
                                                  <span><b>URL:</b></span><a href=""
                                                    [ngClass]="theme ? 'text-white' : 'text-decoration-none text-light'">
                                                    {{position.domain}}
                                                  </a>
                                                </div>
                                                <ng-template #normalDomain>
                                                  <div class="">
                                                    <a href=""
                                                      [ngClass]="theme ? 'text-white' : 'text-decoration-none text-light'"
                                                      class="heading">
                                                      {{position.domain}}
                                                    </a>
                                                  </div>
                                                </ng-template>
                                              </ng-template>
                                            </div>
                                            <div class="mx-1 d-flex">
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                      <td class="text-center"style="width: 100px;">
                                        <span>{{subData?.cpc}}</span></td>
                                    </ng-container>

                                    <ng-template #popContent>
                                      <div class="" (mouseleave)="closePop(i)">
                                        <table class="table " [ngClass]="theme ? 'srtp': 'dark-pop-table'">
                                          <!-- <thead>
                                              <tr class="table-content">
                                                <th scope="col" class="text-secondary"></th>
                                                <th scope="col" class="text-secondary"></th>
                                                <th scope="col" class="text-secondary"></th>
                                              </tr>
                                            </thead> -->
                                          <tbody class="table-body">
                                            <tr *ngFor="let elements of subData?.serpPosition">
                                              <div class="srps-content">
                                                <td class="align-middle">{{elements.position}}</td>
                                                <td class="align-middle">
                                                  <div *ngFor="let serp of elements?.serp">
                                                    <div class="" *ngIf="serp?.key==='quora'">
                                                      <ng-container
                                                        *ngIf="!serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                                        <img src="../../../assets/images/Vector.svg" role="button"
                                                          triggers="mouseenter:mouseleave" alt="" height="20"
                                                          width="20">
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                                        <div class="purple-weak-spot" role="button">
                                                        </div>
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="!serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                                        <div class="blue-weak-spot" role="button">
                                                        </div>
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                                        <div class="purple-weak-spot" role="button">
                                                        </div>
                                                        <div class="blue-weak-spot" role="button">
                                                        </div>
                                                      </ng-container>
                                                    </div>
                                                    <div class="" *ngIf="serp?.key==='reddit'">
                                                      <ng-container
                                                        *ngIf="!serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                                        <img src="../../assets/images/Serp logo.svg" alt="" height="20"
                                                          width="20">
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                                        <div class="purple-weak-spot" role="button">
                                                        </div>
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="!serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                                        <div class="blue-weak-spot" role="button">
                                                        </div>
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                                        <div class="purple-weak-spot" role="button">
                                                        </div>
                                                        <div class="blue-weak-spot" role="button">
                                                        </div>
                                                      </ng-container>
                                                    </div>
                                                    <ng-container
                                                      *ngIf="serp?.key==='all false' || serp?.key==='web 2.0' || serp?.key==='socialmedia' || serp?.key==='filetype'">
                                                      <ng-container
                                                        *ngIf="!serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                                        <div class="no-image" role="button">
                                                        </div>
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                                        <div class="purple-weak-spot" role="button">
                                                        </div>
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="!serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                                        <div class="blue-weak-spot" role="button">
                                                        </div>
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                                        <div class="purple-weak-spot" role="button">
                                                        </div>
                                                        <div class="blue-weak-spot" role="button">
                                                        </div>
                                                      </ng-container>
                                                    </ng-container>
                                                    <ng-container *ngIf="serp?.key==='lowda'">
                                                      <ng-container
                                                        *ngIf="!serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                                        <div
                                                          [ngClass]="serp?.da?.da <=settingsData?.maxDa ? 'color-image rounded-circle text-light' : 'no-image'">
                                                          {{serp?.da?.da <=settingsData?.maxDa ? serp?.da?.da : '' }}
                                                            </div>
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                                        <div class="purple-weak-spot" role="button">
                                                        </div>
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="!serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                                        <div class="blue-weak-spot" role="button">
                                                        </div>
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                                        <div class="purple-weak-spot" role="button">
                                                        </div>
                                                        <div class="blue-weak-spot" role="button">
                                                        </div>
                                                      </ng-container>
                                                    </ng-container>
                                                    <div class="" *ngIf="serp?.key==='forum'">
                                                      <ng-container
                                                        *ngIf="!serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                                        <img src="../../../assets/images/comments-alt.svg" alt=""
                                                          height="20" width="20">
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="serp?.serp?.isCustomDomain && !serp?.serp?.isMySites">
                                                        <div class="purple-weak-spot" role="button">
                                                        </div>
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="!serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                                        <div class="blue-weak-spot" role="button">
                                                        </div>
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="serp?.serp?.isCustomDomain && serp?.serp?.isMySites">
                                                        <div class="purple-weak-spot" role="button">
                                                        </div>
                                                        <div class="blue-weak-spot" role="button">
                                                        </div>
                                                      </ng-container>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td>
                                                  <div class="w-500 ps-2">
                                                    <p class="m-0 p-0 heading">{{elements?.title}}</p>
                                                    <a target="_blank" href="{{elements?.link}}"
                                                      class="text-decoration-none fw-600 overflow-ellipsis">
                                                      {{elements?.link}}
                                                    </a>
                                                  </div>
                                                </td>
                                              </div>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>

                                    </ng-template>
                                  </ng-container>
                                </tr>
                              </ng-container>
                            </tbody>
                          </table>
                          <div class="d-flex justify-content-end align-items-center mt-2" *ngIf="data.totalCount>50">
                            <ngb-pagination [collectionSize]="data.totalCount" [maxSize]="3" [(page)]="data.page"
                              [pageSize]="tableSize" [rotate]="true" (pageChange)="getClusterData(i);"></ngb-pagination>
                          </div>
                        </div>
                      </td>

                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
          <div class="d-flex justify-content-between align-items-center px-2 pt-4"
            [ngClass]="theme ? 'bg-white': 'dark-table'" *ngIf="activateLink!=='Settings' && !loading">
            <div>
              <h3>Show {{paginateData?.length>0 ? totalData : 0}} of {{tabWiseCount}} items</h3>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <ngb-pagination [collectionSize]="tabWiseCount" [maxSize]="3" [(page)]="page" [pageSize]="tableSize"
                [rotate]="true" (pageChange)="filterQueryBuilder()"></ngb-pagination>
              <div class="d-flex justify-content-end align-items-center mb-3" *ngIf="activateLink!=='clusters'">
                <label id="ViewBySortLabel" class="fw-600 fs-14 Neutral mb-1">Entries per page</label>
                <mat-form-field appearance="outline" class="col-4 country-input" [ngClass]="theme ? '': 'dark-input'">
                  <mat-select [(ngModel)]="tableSize" (selectionChange)="filterQueryBuilder('fromSelChange')">
                    <mat-option value="10" [ngClass]="theme ? '': 'dark-dropdown'"
                      *ngIf="activateLink==='clusters'">10</mat-option>
                    <mat-option value="25" [ngClass]="theme ? '': 'dark-dropdown'">25</mat-option>
                    <mat-option value="50" [ngClass]="theme ? '': 'dark-dropdown'">50</mat-option>
                    <mat-option value="100" [ngClass]="theme ? '': 'dark-dropdown'">100</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="jumpToPage d-flex justify-content-end align-items-center mb-3" style="width: 50px;">
                <input type="number" min="1" max="count" [(ngModel)]="jumpToPageCount" class="form-control"
                  (keyup.enter)="jumpToPageCount <= count && jumpToPage()">
                <!-- <button class="btn btn-outline-primary mx-1 mt-1"
                    [disabled]="(jumpToPageCount > count || jumpToPageCount===0 || !jumpToPageCount || jumpToPageCount===page)"
                    (click)="jumpToPage()">Go</button> -->
              </div>
            </div>
          </div>
          <div class="col-6  border rounded bg-white position-relative" *ngIf="activateLink=='Settings'">
            <app-dashboard-settings *ngIf="isLogin" [settings]="settingsData" [isDashboard2]="true" [lid]="keyWordId"
              (settingsData)=onSettingsAdd($event)></app-dashboard-settings>
          </div>
        </div>
        <div class="fixed-popup shadow p-2 rounded" *ngIf="!!showPopup" [ngClass]="theme ? 'bg-white' : 'bg-dark'">
          <div class="align-items-center">
            <!-- <button *ngIf="activateLink == 'clusters'" class="btn btn-outline-primary me-1  py-1 px-2 text-nowrap"
                [disabled]="(topResults || SERPSimilarity) ==''" (click)="getAllData()">Start Clusturing</button> -->
            <button class="btn btn-outline-primary py-1 px-2 text-nowrap me-1" (click)="refresh()"
              matTooltip="Refresh for getting new changes"
              *ngIf="isLogin && keyWordType != 'list' &&  (activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question')">
              <i class="bi bi-arrow-clockwise"></i> Refresh
            </button>
            <div class="btn-group" role="group" aria-label="Basic example">
              <button class="btn btn-outline-primary py-1 px-2 text-nowrap" *ngIf="activateLink == 'clusters'"
                [matMenuTriggerFor]="settingsMenu" (menuOpened)="getCredit()">
                <i class="bi bi-gear"></i> Settings
              </button>

              <button class="btn btn-outline-primary py-1 px-2 text-nowrap" [disabled]="buttonState() || !!isDisable || (!userData || userData?.serp_max_credit - userData?.serp_credit ==0)"
                (click)="performSerpExtract()" matTooltip="Analyse selected keywords"
                *ngIf="isLogin && (activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question')">
                <i class="bi bi-hdd-stack me-1"></i> Analyze Keywords
              </button>
              <button class="btn btn-outline-primary py-1 px-2" ngbPopover="Analyse Intent keywords" [disabled]="(!userData || userData?.serp_max_credit - userData?.serp_credit ==0)"
                popoverClass="{{popover}}" container="body" triggers="mouseenter:mouseleave"
                *ngIf="keyWordType != 'list' && isLogin && (activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question')"
                [matMenuTriggerFor]="menu" (menuOpened)="getCredit()">
                <i class="mt-1 bi bi-chevron-down me-1"></i>
              </button>
            </div>
            <!-- <button *ngIf="isLogin && keyWordType != 'list'" class="btn btn-outline-primary ms-1 py-1 px-2 text-nowrap "
                [disabled]="buttonState()" matTooltip="Hide selected keywords" [hidden]="activateLink === 'hidden'"
                (click)="handleHide(true)">
                <i class="bi bi-eye-slash me-1"></i> Hide
              </button> -->
            <!-- <button class="btn btn-outline-primary ms-1 py-1 px-2 text-nowrap" matTooltip="Unhide selected keywords"
                [disabled]="buttonState()" (click)="handleHide(false)" *ngIf="activateLink === 'hidden'">
                <i class="bi bi-eye me-1"></i> Unhide
              </button> -->
            <button *ngIf="isLogin && keyWordType!=='list'"
              class="btn btn-outline-primary ml-auto ms-1 py-1 px-2 text-nowrap " (click)="linkCopy()"
              ngbPopover="Share Report" popoverClass="{{popover}}" container="body" triggers="mouseenter:mouseleave">
              <i class="bi bi-clipboard me-1"></i>
            </button>
            <button [disabled]="excelLoader"
            *ngIf="keyWordType == 'list'"
            class="btn btn-outline-primary ml-auto ms-1 py-1 px-2 text-nowrap" style="white-space: nowrap;"
            (click)="downloadAllData()" ngbPopover="Export all as excel" popoverClass="{{popover}}" container="body"
            triggers="mouseenter:mouseleave">
            <i class="bi bi-file-earmark-medical" *ngIf="!excelLoader;else loading"></i>
            <ng-template #loading>
              <div class="spinner-border text-primary pt-1" role="status"
                style="width: 15px !important; height: 15px !important;"></div>
            </ng-template>
          </button>
            <button [disabled]="excelLoader"
            *ngIf="keyWordType != 'list' && activateLink !=='clusters' && activateLink !=='paa' && activateLink !=='competition' && activateLink !=='related_search' "
            class="btn btn-outline-primary ml-auto ms-1 py-1 px-2 text-nowrap" style="white-space: nowrap;"
            (click)="downloadAllData()" ngbPopover="Export all as excel" popoverClass="{{popover}}" container="body"
            triggers="mouseenter:mouseleave">
            <i class="bi bi-file-earmark-medical" *ngIf="!excelLoader;else loading"></i>
            <ng-template #loading>
              <div class="spinner-border text-primary pt-1" role="status"
                style="width: 15px !important; height: 15px !important;"></div>
            </ng-template>
          </button>

          <button
            *ngIf="(activateLink =='paa' || activateLink == 'competition' || activateLink =='related_search') "
            class="btn btn-outline-primary ml-auto ms-1 py-1 px-2 text-nowrap" style="white-space: nowrap;"
            (click)="downloadAllData()" matTooltip="Export {{activateLink}} data as excel">
            <i class="bi bi-file-earmark-medical" *ngIf="!separateExcelLoader;else loading"></i>
            <ng-template #loading>
              <div class="spinner-border text-primary pt-1" role="status"
                style="width: 15px !important; height: 15px !important;"></div>
            </ng-template>
          </button>
            <!-- <button
              *ngIf="isAllChecked && (activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question')"
              class="btn btn-outline-primary ml-auto ms-1 py-1 px-2 text-nowrap" style="white-space: nowrap;"
              (click)="downloadFile()" ngbPopover="Export selected as excel" popoverClass="{{popover}}" container="body"
              triggers="mouseenter:mouseleave">
              <i class="bi bi-file-earmark-arrow-up me-1"></i>
            </button> -->


            <div class="btn-group ms-1" role="group" aria-label="Basic example">
              <button class="btn btn-outline-primary py-1 px-2 text-nowrap" [disabled]="buttonState()"
                [matMenuTriggerFor]="listMenu" matTooltip="Add To list"
                *ngIf="isLogin && (activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question') && keyWordType!=='list'">
                Add to List
              </button>
              <button class="btn btn-outline-primary py-1 px-2" [disabled]="buttonState()"
                ngbPopover="Analyse Intent keywords" popoverClass="{{popover}}" container="body"
                triggers="mouseenter:mouseleave"
                *ngIf="keyWordType != 'list' && isLogin && (activateLink == 'all' || activateLink == 'suggestion' || activateLink == 'question')"
                [matMenuTriggerFor]="listMenu">
                <i class="mt-1 bi bi-chevron-down me-1"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- </div> -->


  <ng-template #SelectKeywords let-modal>
    <!-- <div class="position-relative">
        <button type="button" style="font-size: 10px;margin-top: 5px;margin-right: 1px;"
          class="position-absolute top-0 end-0 btn-close closeButton" aria-label="Close"
          (click)="modal.dismiss('Cross click')"></button>
      </div> -->
    <div class="curr_page">
      <input class="form-check-input" type="checkbox" (change)="CheckAll()" [(ngModel)]="masterSelected" role="button"
        *ngIf="activateLink !== 'clusters'" [disabled]="!!allSelect">
      <label style="padding-left:6px;padding-bottom:6px;">Current Page</label><br>
      <input class="form-check-input" type="checkbox" (change)="allPageSelect()" *ngIf="activateLink !== 'clusters'"
        [(ngModel)]="allSelect" role="button">
      <label style="padding-left:6px;padding-bottom:6px;">All pages</label>
    </div>
  </ng-template>

  <ng-template #Delete let-modal>
    <div class="p-4 text-center">
      <div class="position-relative">
        <h2 class="text-center text-danger fw-bold">Delete list</h2>
        <button type="button" class="position-absolute top-0 end-0 btn-close" aria-label="Close"
          (click)="modal.dismiss('Cross click')"></button>
      </div>
      <div>
        <p class="fs-16">Do you want to delete this list?</p>
      </div>
      <div class="d-flex mt-4">
        <button type="button" class="btn btn-primary me-1 w-50" (click)="modal.close('Close click')">Cancel</button>
        <button type="button" class="btn btn-outline-primary ms-1 w-50" (click)="onDelete()">Delete</button>
      </div>
    </div>
  </ng-template>

  <ng-template #addNewList let-modal>
    <div class="p-4">
      <div class="position-relative heading-border pb-3">
        <h1 class="fw-bold m-0">New list name</h1>
        <button type="button" class="position-absolute top-0 end-0 btn-close" aria-label="Close"
          (click)="modal.dismiss('Cross click')"></button>
      </div>
      <div class="overflow-content">
        <div class="mt-3">
          <input type="text" [(ngModel)]="listName" class="input w-100 pe-36" placeholder="Enter list name">

          <!-- <input type="text" [(ngModel)]="listName" class="input" > -->
        </div>
      </div>
      <div class="d-flex mt-4 justify-content-end">
        <button type="button" class="btn btn-outline-primary me-1 px-5"
          (click)="modal.close('Close click')">Cancel</button>
        <button type="button" class="btn btn-primary ms-1 px-5" (click)="addOneListName()">Add</button>
      </div>
    </div>
  </ng-template>

  <!-- PopOver for View SRTP -->

  <ng-template #customLoadingTemplate>
    <div class="custom-class">
      <!-- <h3>Loading...</h3> -->
    </div>
  </ng-template>
  <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"
    [template]="customLoadingTemplate"></ngx-loading>

  <mat-menu [class]="theme === false ? 'customize' : ''" #menu="matMenu" (click)="$event.stopPropagation();">
    <div class="m-2">
      <h3 class="m-2 text-center fw-600">
        Quickly analyze keywords based on intent
      </h3>
      <table class="p-3">
        <tr>
          <th class="p-2">Intent</th>
          <th class="p-2">Credits required</th>
          <th class="p-2"></th>
        </tr>
        <tr *ngFor="let item of analyseMenuArray">
          <td scope="row" class="p-2">
            <div class="d-flex align-items-center">
              <h4 class="m-0 pe-3" [ngClass]="{'' : item==='Analyze Whole keyword report'}">{{item}}</h4>
              <ng-container *ngIf="item==='High - Intent'">
                <i class="bi bi-exclamation-circle-fill light-txt" triggers="mouseenter:mouseleave"
                  [ngbPopover]="highIntent" popoverClass="{{popover}}"></i>
              </ng-container>
              <ng-container *ngIf="item==='Pre - Purchase'">
                <i class="bi bi-exclamation-circle-fill light-txt" triggers="mouseenter:mouseleave"
                  [ngbPopover]="PrePurchase" popoverClass="{{popover}}"></i>
              </ng-container>
              <ng-container *ngIf="item==='Post - Purchase'">
                <i class="bi bi-exclamation-circle-fill light-txt" triggers="mouseenter:mouseleave"
                  [ngbPopover]="PostPurchase" popoverClass="{{popover}}"></i>
              </ng-container>
              <ng-container *ngIf="item==='Comparision'">
                <i class="bi bi-exclamation-circle-fill light-txt" triggers="mouseenter:mouseleave"
                  [ngbPopover]="Comparison" popoverClass="{{popover}}"></i>
              </ng-container>
              <ng-container *ngIf="item==='Analyze Whole keyword report'">
                <i class="bi bi-exclamation-circle-fill light-txt" triggers="mouseenter:mouseleave"
                  [ngbPopover]="analyseAll" popoverClass="{{popover}}"></i>
              </ng-container>
              <ng-template #highIntent>
                <div class="mb-2 max-272">
                  <div>
                    High Intent: Shows all the keywords which have following keywords in it
                  </div>
                  <div>
                    1. Best
                  </div>
                  <div>
                    2. Review
                  </div>
                  <div>
                    3. Free
                  </div>
                </div>
              </ng-template>
              <ng-template #PrePurchase>
                <div class="mb-2 max-272">
                  <div>
                    Pre-Purchase: Show all the keywords which have following keywords in it
                  </div>
                  <div>
                    1. Discounts
                  </div>
                  <div>
                    2. Best
                  </div>
                  <div>
                    3. Review
                  </div>
                  <div>
                    4. Buy
                  </div>
                </div>
              </ng-template>
              <ng-template #PostPurchase>
                <div class="mb-2 max-272">
                  <div>
                    Post-purchase: Show all the keywords which have follwing keywords in it
                  </div>
                  <div>
                    1. Problem
                  </div>
                  <div>
                    2. Warranty
                  </div>
                  <div>
                    3. Broken
                  </div>
                  <div>
                    4. clean
                  </div>
                </div>
              </ng-template>
              <ng-template #Comparison>
                <div class="mb-2 max-272">
                  <div>
                    Comparison: Show all the keywords which have follwing keywords in it
                  </div>
                  <div>
                    1. vs
                  </div>
                  <div>
                    2. Compare
                  </div>
                  <div>
                    3. Comparison
                  </div>
                  <div>
                    4. alternative
                  </div>
                  <div>
                    5. alternatives
                  </div>
                  <div>
                    6. Difference
                  </div>
                  <div>
                    7. Compared to
                  </div>
                </div>
              </ng-template>
              <ng-template #analyseAll>
                <div class="mb-2 max-272">
                  <div>
                    Analyse All: Show all the keywords
                  </div>
                </div>
              </ng-template>
            </div>
          </td>

          <td scope="row" class="p-2">
            <ng-container [ngSwitch]="item">
              <ng-container *ngSwitchCase="'High - Intent'" [ngTemplateOutlet]="highintentLengthtemp"></ng-container>
              <ng-container *ngSwitchCase="'Pre - Purchase'" [ngTemplateOutlet]="prePurchaseLengthtemp"></ng-container>
              <ng-container *ngSwitchCase="'Post - Purchase'"
                [ngTemplateOutlet]="postPurchaseLengthtemp"></ng-container>
              <ng-container *ngSwitchCase="'Comparision'" [ngTemplateOutlet]="comparisionLengthtemp"></ng-container>
              <ng-container *ngSwitchCase="'Analyze Whole keyword report'"
                [ngTemplateOutlet]="wholeKeywordReportLengthtemp"></ng-container>
            </ng-container>
            <ng-template #highintentLengthtemp>
              {{lckrCountData.high_intent}}
            </ng-template>
            <ng-template #prePurchaseLengthtemp>
              {{lckrCountData.pre_purchase}}
            </ng-template>
            <ng-template #postPurchaseLengthtemp>
              {{lckrCountData.post_purchase}}
            </ng-template>
            <ng-template #comparisionLengthtemp>
              {{lckrCountData.competitor}}
            </ng-template>
            <ng-template #wholeKeywordReportLengthtemp>
              {{lckrCountData.total_kws}}
            </ng-template>
          </td>

          <td class="p-2">
            <button type="button" class="btn btn-outline-primary w-auto rounded-pill px-4 fs-12 d-flex"
              (click)="$event.stopPropagation();openDialog(item)" [disabled]="buttonArg.includes(item)">Analyze</button>
          </td>
        </tr>
      </table>
    </div>
  </mat-menu>

  <mat-menu [class]="theme === false ? 'customize' : ''" style="text-align:center !important;" #listMenu="matMenu">

    <button (click)="openModel(addNewList)" type="button"
      class="btn btn-outline-primary py-1 px-2 text-nowrap ml-button">Create New List</button>

    <mat-list [class]="theme === false ? 'customize' : ''" class="pl-3" role="list">
      <mat-list-item *ngFor="let item of Lists;let i = index;" role="listitem">
        <span class="list-name" (click)="saveListData(item.id)">{{i+1}}. {{item.name}}</span>
      </mat-list-item>
    </mat-list>
  </mat-menu>

  <mat-menu [class]="theme === false ? 'customize' : ''" #settingsMenu="matMenu">
    <div class="d-flex justify-content-center m-3">
      <!-- <div>
          <p>in top search results</p>
          <mat-form-field appearance="outline" (click)="$event.stopPropagation()" class="w-200"
            [ngClass]="theme ? '': 'dark-input' ">
            <mat-select [value]="topResults" [(ngModel)]="topResults">
              <mat-option value="2">2</mat-option>
              <mat-option value="3">3</mat-option>
              <mat-option value="4">4</mat-option>
              <mat-option value="5">5</mat-option>
              <mat-option value="6">6</mat-option>
              <mat-option value="7">7</mat-option>
              <mat-option value="8">8</mat-option>
              <mat-option value="9">9</mat-option>
              <mat-option value="10">10</mat-option>
  
            </mat-select>
          </mat-form-field>
        </div> -->

      <div class="ms-2">
        <p matTooltip="Configure SERP Similarity Threshold - Establish a threshold for SERP similarity among top search results to form clusters. For instance, keywords with a minimum of 40% SERP similarity within the top 10 results will be grouped together in a single cluster, requiring at least 4 matching URLs"
          matTooltipClass="{{theme ? 'custom-tooltip' : ''}}">SERP similarity</p>
        <mat-form-field appearance="outline" (click)="$event.stopPropagation()" class="w-200"
          [ngClass]="theme ? '': 'dark-input' ">
          <mat-select [value]="SERPSimilarity" [(ngModel)]="SERPSimilarity">
            <mat-option value="1">10%</mat-option>
            <mat-option value="2">20%</mat-option>
            <mat-option value="3">30%</mat-option>
            <mat-option value="4">40%</mat-option>
            <mat-option value="5">50%</mat-option>
            <mat-option value="6">60%</mat-option>
            <mat-option value="7">70%</mat-option>
            <mat-option value="8">80%</mat-option>
            <mat-option value="9">90%</mat-option>
            <mat-option value="10">100%</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </mat-menu>

  <ng-template #confirmationDialog>
    <ng-container [ngSwitch]="confirmationPopupData">
      <ng-container *ngSwitchCase="'High - Intent'" [ngTemplateOutlet]="highintentLengthpopup"></ng-container>
      <ng-container *ngSwitchCase="'Pre - Purchase'" [ngTemplateOutlet]="prePurchaseLengthpopup"></ng-container>
      <ng-container *ngSwitchCase="'Post - Purchase'" [ngTemplateOutlet]="postPurchaseLengthpopup"></ng-container>
      <ng-container *ngSwitchCase="'Comparision'" [ngTemplateOutlet]="comparisionLengthpopup"></ng-container>
      <ng-container *ngSwitchCase="'Analyze Whole keyword report'"
        [ngTemplateOutlet]="wholeKeywordReportLengthpopup"></ng-container>
    </ng-container>
    <ng-template #highintentLengthpopup>
      <div>
        <h1 class="p-0 m-0 fw-600 text-center heading">Quick Analyze?</h1>
        <p class="mt-3">This report consist of <b>"{{lckrCountData.high_intent}}"</b>
          keywords with a
          <b>"{{confirmationPopupData}}"</b>. It will Consume
          <b>{{lckrCountData.high_intent}}</b> SERP Credits to proceed. Would you
          like to proceed?
        </p>
      </div>
    </ng-template>
    <ng-template #prePurchaseLengthpopup>
      <div>
        <h1 class="p-0 m-0 fw-600 text-center heading">Quick Analyze?</h1>
        <p class="mt-3">This report consist of
          <b>"{{lckrCountData.pre_purchase}}"</b> keywords with a
          <b>"{{confirmationPopupData}}"</b>. It will Consume
          <b>{{lckrCountData.pre_purchase}}</b> SERP Credits to proceed. Would you
          like to proceed?
        </p>
      </div>
    </ng-template>
    <ng-template #postPurchaseLengthpopup>
      <div>
        <h1 class="p-0 m-0 fw-600 text-center heading">Quick Analyze?</h1>
        <p class="mt-3">This report consist of
          <b>"{{lckrCountData.post_purchase}}"</b> keywords with a
          <b>"{{confirmationPopupData}}"</b>. It will Consume
          <b>{{lckrCountData.post_purchase}}</b> SERP Credits to proceed. Would you
          like to proceed?
        </p>
      </div>
    </ng-template>
    <ng-template #comparisionLengthpopup>
      <div>
        <h1 class="p-0 m-0 fw-600 text-center heading">Quick Analyze?</h1>
        <p class="mt-3">This report consist of <b>"{{lckrCountData.competitor}}"</b>
          keywords with a
          <b>"{{confirmationPopupData}}"</b>. It will Consume
          <b>{{lckrCountData.competitor}}</b> SERP Credits to proceed. Would you like
          to proceed?
        </p>
      </div>
    </ng-template>
    <ng-template #wholeKeywordReportLengthpopup>
      <div>
        <h1 class="p-0 m-0 fw-600 text-center heading">Quick Analyze?</h1>
        <p class="mt-3">This report consist of <b>"{{lckrCountData.total_kws}}"</b>
          keywords with a
          <b>"{{confirmationPopupData}}"</b>. It will Consume
          <b>{{lckrCountData.total_kws}}</b> SERP Credits to proceed. Would you like to
          proceed?
        </p>
      </div>
    </ng-template>
    <!-- <div>
      <h1 class="p-0 m-0 fw-600 text-center">Quick Analyze?</h1>
      <p class="mt-3">Are you sure you want to analyze <b>{{confirmationPopupData}}</b> data. it will consume
        <b>{{getCredit(confirmationPopupData)}}</b> credit</p>
    </div> -->
    <div class="d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-auto fs-12 me-2"
        (click)="$event.stopPropagation();analyseByIntent(confirmationPopupData)">Yes</button>
      <button type="button" class="btn btn-outline-primary w-auto fs-12"
        (click)="$event.stopPropagation();cancelDialog()">No</button>
    </div>
  </ng-template>